// English source strings. Every other catalog must have these keys, plus any extra plural forms its language uses (checked by the Messages type).
// {name} is a placeholder filled in by t() or tx().

// Phase 1 keeps these new rule/registry labels in English in every locale. Later translation work can
// override individual keys without letting registry-owned display strings bypass i18n.
export const ruleEnglishFallbacks = {
  'bt.rules.labeledLevel': '{label} ({price})',
  'bt.rules.line.env.upper': 'Upper',
  'bt.rules.line.env.basis': 'Basis',
  'bt.rules.line.env.lower': 'Lower',
  'bt.rules.line.adx.adx': 'ADX',
  'bt.rules.line.adx.plusDI': '+DI',
  'bt.rules.line.adx.minusDI': '−DI',
  'bt.rules.line.ichimoku.tenkan': 'Conversion',
  'bt.rules.line.ichimoku.kijun': 'Base',
  'bt.rules.line.ichimoku.senkouA': 'Lead A',
  'bt.rules.line.ichimoku.senkouB': 'Lead B',
  'bt.rules.line.ichimoku.chikou': 'Lagging',
  'bt.rules.line.supertrend.up': 'Up trend',
  'bt.rules.line.supertrend.down': 'Down trend',
  'bt.rules.line.aroon.up': 'Up',
  'bt.rules.line.aroon.down': 'Down',
  'bt.rules.line.macd.histogram': 'Histogram',
  'bt.rules.line.macd.macd': 'MACD',
  'bt.rules.line.macd.signal': 'Signal',
  'bt.rules.line.stoch.k': '%K',
  'bt.rules.line.stoch.d': '%D',
  'bt.rules.line.stochrsi.k': 'K',
  'bt.rules.line.stochrsi.d': 'D',
  'bt.rules.line.bb.upper': 'Upper',
  'bt.rules.line.bb.middle': 'Basis',
  'bt.rules.line.bb.lower': 'Lower',
  'bt.rules.line.kc.upper': 'Upper',
  'bt.rules.line.kc.middle': 'Basis',
  'bt.rules.line.kc.lower': 'Lower',
  'bt.rules.line.dc.upper': 'Upper',
  'bt.rules.line.dc.basis': 'Basis',
  'bt.rules.line.dc.lower': 'Lower',

  // Rule builder (features/backtest/rules/RuleBuilder.tsx). English in every locale until translated.
  'bt.rules.build': 'Build your own',
  'bt.rules.buildBody': 'Buy and sell rules from the indicators on your chart.',
  'bt.rules.buildBodyCount': 'Uses the indicators on your chart ({count}).',
  'bt.rules.templateOwnSettings': 'Uses its own settings, not your chart’s.',
  'bt.rules.onChart': 'On your chart',
  'bt.rules.onChartHint': 'Click one to put it in the rule you are editing.',
  'bt.rules.onChartEmpty': 'No indicators or horizontal lines on this chart yet. Pick any indicator in a rule below.',
  'bt.rules.chipReason': '{name}: {reason}',
  'bt.rules.chipLevel': 'Line at {price}',
  'bt.rules.reason.unknown': 'Not available in backtests.',
  'bt.rules.reason.params': '{param} {value} is outside {min}–{max} for backtest rules.',
  'bt.rules.note.vwma': 'The volume weighted moving average is not available in backtests yet.',
  'bt.rules.note.env': 'Envelopes are not available in backtests yet.',
  'bt.rules.note.cmo': 'The Chande momentum oscillator is not available in backtests yet.',
  'bt.rules.note.stdev': 'Standard deviation is not available in backtests yet.',
  'bt.rules.note.vpvr': 'The volume profile is a drawing, not a line, and cannot be used in a rule.',
  'bt.rules.note.obv': 'On-balance volume is a running total from the first bar, so its level depends on where the data starts and cannot match the chart.',
  'bt.rules.note.ichimoku': 'Ichimoku is too slow to backtest yet.',
  'bt.rules.note.volma': 'The volume moving average is too slow to backtest yet.',
  'bt.rules.note.trix': 'Calculated from prices rather than log prices, so values differ slightly from the chart (zero crossings agree closely).',
  'bt.rules.note.vwap': 'The daily reset depends on how many bars the backtest keeps; on short timeframes it can start mid-day and differ from the chart.',
  'bt.rules.buySection': 'Buy when',
  'bt.rules.buyHint': 'all of these hold',
  'bt.rules.sellSection': 'Sell when',
  'bt.rules.sellHint': 'any of these holds',
  'bt.rules.addBuy': 'Add buy rule',
  'bt.rules.addSell': 'Add sell rule',
  'bt.rules.removeRule': 'Remove {side} rule {n}',
  'bt.rules.ruleLabel': '{side} rule {n}',
  'bt.rules.sideBuy': 'Buy',
  'bt.rules.sideSell': 'Sell',
  'bt.rules.left': 'first value',
  'bt.rules.right': 'second value',
  'bt.rules.operandLabel': '{rule}, {slot}',
  'bt.rules.operator': '{rule}, condition',
  'bt.rules.opShort.crossesAbove': 'crosses above',
  'bt.rules.opShort.crossesBelow': 'crosses below',
  'bt.rules.opShort.above': 'above',
  'bt.rules.opShort.below': 'below',
  'bt.rules.pick': 'Choose…',
  'bt.rules.group.chart': 'On your chart',
  'bt.rules.group.price': 'Price',
  'bt.rules.group.levels': 'Horizontal lines',
  'bt.rules.group.rule': 'In this rule',
  'bt.rules.group.other': 'Other indicators (default settings)',
  'bt.rules.numberOption': 'A number',
  'bt.rules.numberValue': '{operand}, number',
  'bt.rules.addToChart': 'Add {name} to chart',
  'bt.rules.notOnChart': 'Not on your chart',
  'bt.rules.exits': 'Exits and size',
  'bt.rules.stopLossPct': 'Stop-loss %',
  'bt.rules.takeProfitPct': 'Take-profit %',
  'bt.rules.entryPct': 'Entry size (% of balance)',
  'bt.rules.optional': 'Optional, {min}–{max}',
  'bt.rules.sentenceLabel': 'Your strategy',
  'bt.rules.viewCode': 'View as nori code',
  'bt.rules.code': 'Generated nori code',
  'bt.rules.codeUnavailable': 'Complete the rules to see the code.',
  'bt.rules.runBlocked': 'Cannot run yet: {reason}',
  'bt.rules.err.missing': 'Choose a value.',
  'bt.rules.err.number': 'Enter a number.',
  'bt.rules.err.range': 'Use a value from {min} to {max}.',
  'bt.rules.err.constant': 'One side must be an indicator or the price.',
  'bt.rules.err.noEntry': 'Add at least one buy rule.',
  'bt.rules.err.noExit': 'Add a sell rule, a stop-loss or a take-profit, or the position is never closed.',
  'bt.rules.err.tooManyRules': 'At most {max} rules here.',
  'bt.rules.err.tooManyLines': 'Too many indicator lines; use at most {max}.',
  'bt.rules.err.tooManyIndicators': 'Use at most {max} different indicator settings in one strategy.',
  'bt.rules.err.tooComplex': 'This indicator combination is too heavy for one backtest; use fewer or lighter indicators.',
  'bt.rules.err.unsupported': 'This indicator is not available in backtests.',
  'bt.rules.err.invalid': 'This value is not valid.',
  'bt.rules.describe': 'Describe it',
  'bt.rules.describeHint': 'Say when to buy and sell; the AI fills in the rules below. Nothing runs until you press Run.',
  'bt.rules.describePlaceholder': 'e.g. buy when RSI crosses above 30 and price is above the EMA, sell when RSI crosses below 70',
  'bt.rules.fill': 'Fill',
  'bt.rules.filling': 'Filling…',
  'bt.rules.filled': 'Rules filled in. Check them, then press Run.',
  'bt.rules.describeUnavailable': 'Describing a strategy is not available right now.',
  'bt.rules.describeFailed': 'Could not fill the rules: {message}',
  'bt.rules.my': 'My strategies',
  'bt.rules.myEmpty': 'Nothing saved yet. Saved strategies stay in this browser.',
  'bt.rules.saveName': 'Strategy name',
  'bt.rules.save': 'Save',
  'bt.rules.saved': 'Saved “{name}”.',
  'bt.rules.saveInvalid': 'Fix the rules before saving.',
  'bt.rules.saveFull': 'You can keep {max} strategies. Delete one first.',
  'bt.rules.saveFailed': 'Could not save in this browser.',
  'bt.rules.loadNamed': 'Load {name}',
  'bt.rules.deleteNamed': 'Delete {name}',
  'bt.rules.load': 'Load',
  'bt.rules.delete': 'Delete',
  'bt.rules.deleted': 'Deleted “{name}”.',
  'bt.rules.loaded': 'Loaded “{name}”.',
  'bt.card.editRules': 'Edit as rules',
} as const;

export const en = {
  // Site header and footer
  'nav.chart': 'Chart',
  'nav.markets': 'Markets',
  'nav.ai': 'AI analyst',
  'nav.widgets': 'Widgets',
  'nav.main': 'Main',
  'nav.menu': 'Menu',
  'nav.more': 'More',
  'nav.openChart': 'Open the chart',
  'nav.home': 'Cryptohopper Charts home',
  'nav.signUp': 'Sign up',
  'nav.dashboard': 'Dashboard',
  'nav.toCryptohopper': 'Go to www.cryptohopper.com',
  'theme.light': 'Light theme',
  'theme.dark': 'Dark theme',
  'language.label': 'Language',
  'footer.disclaimer': 'Market data comes directly from the exchanges’ public APIs. Nothing on this site is financial advice.',
  'footer.terms': 'Terms',
  'footer.bottom': '© {year} Cryptohopper. Crypto assets are volatile; trade with care.',

  // Error and 404 pages
  'notFound.title': 'Page not found · Cryptohopper Charts',
  'notFound.heading': 'This page does not exist',
  'notFound.body': 'The link may be old. The chart, markets and widgets are one click away.',
  'error.heading': 'Something went wrong',
  'error.newVersion': 'A new version of Cryptohopper Charts was just published. Reload to get it.',
  'error.body': 'The page hit an unexpected error. Reloading usually fixes it; your layouts and settings are kept.',
  'error.reload': 'Reload',
  'error.home': 'Go home',

  // Landing page
  'landing.metaTitle': 'Cryptohopper Charts: free advanced crypto charts, AI chart analysis & widgets',
  'landing.metaDescription':
    'Free pro-grade crypto charts with live data from six exchanges, 38 indicators, drawing tools, up to 8 charts per window and free widgets, no account needed. Plus an AI chart analyst, free with a Cryptohopper account.',
  'hero.title1': 'Pro-grade crypto charts.',
  'hero.title2': 'Free, no account.',
  'hero.lead': 'Real-time candles from six exchanges, 38 indicators, drawing tools, up to 8 synced charts and an AI analyst.',
  'hero.askAi': 'Ask the AI analyst',
  'hero.noSignup': 'No sign-up for the charts',
  'hero.aiAccount': 'Free AI questions with a Cryptohopper account',
  'hero.market': 'Market',
  'hero.interval': 'Interval',
  'hero.chartLabel': 'Live {pair} chart from {exchange}, {interval} per candle',

  'exchanges.title': 'Bitcoin on six exchanges, live',
  'exchanges.lead': 'Every price on this site streams straight from the exchange’s own public feed.',
  'exchanges.browse': 'Browse all markets',
  'exchanges.unreachable': 'Not reachable from your network',
  'exchanges.highest': 'Highest',
  'exchanges.lowest': 'Lowest',
  'exchanges.spread': 'Right now the highest and lowest USD and USDT prices are {pct} apart.',

  'terminal.title': 'Up to eight charts in one window',
  'terminal.lead':
    'Split the screen up to eight ways and keep symbol, interval, crosshair and time in sync. Hover a chart below and watch the others follow.',
  'terminal.leadTouch':
    'Split the screen up to eight ways and keep symbol, interval, crosshair and time in sync. Press and hold a chart below and watch the others follow.',
  'terminal.chartLabel': 'Live {pair} chart from {exchange}, {chartType}, one hour per candle',
  'terminal.watchlists': 'Watchlists',
  'terminal.watchlistsText': 'As many lists as you like, with live prices and 24h change.',
  'terminal.alerts': 'Price alerts',
  'terminal.alertsText': 'Crossing, above or below a price. A browser notification fires while a tab is open.',
  'terminal.layouts': 'Layouts and share links',
  'terminal.layoutsText': 'Layouts save in your browser. Send one, drawings included, as a single link.',
  'terminal.snapshots': 'Snapshots',
  'terminal.snapshotsText': 'Download the chart as an image or copy it straight to the clipboard.',
  'terminal.shortcuts': 'Keyboard shortcuts',
  'terminal.shortcutsText': 'Type a symbol or an interval to switch. {altT} draws a trend line, {ctrlS} saves the layout.',
  'terminal.themes': 'Dark and light',
  'terminal.themesText': 'One switch for the chart and everything around it.',

  'indicators.title': '38 indicators, stacked the way you trade',
  'indicators.lead': 'Run SMA 50 and SMA 200 together, RSI under MACD, Bollinger Bands over Ichimoku. Try a few on the live ETH chart.',
  'indicators.chartLabel': 'Live ETH/USDT chart from Binance, four hours per candle, {chartType}',
  'indicators.chartLabelWith': 'Live ETH/USDT chart from Binance, four hours per candle, {chartType}, with {indicators}',
  'indicators.heading': 'Indicators',
  'indicators.more': '28 more in the terminal, from Hull and Keltner to Aroon and Chaikin Money Flow.',
  'indicators.chartType': 'Chart type',
  'indicators.moreTypes': 'Plus hollow candles, line with markers, step line and columns.',
  'chartType.candles': 'Candles',
  'chartType.hollow': 'Hollow candles',
  'chartType.heikin': 'Heikin Ashi',
  'chartType.bar': 'Bars',
  'chartType.line': 'Line',
  'chartType.line_markers': 'Line with markers',
  'chartType.step': 'Step line',
  'chartType.area': 'Area',
  'chartType.baseline': 'Baseline',
  'chartType.columns': 'Columns',
  'hcbar.candleInterval': 'Candle interval',
  'hcbar.channel': 'Channel',
  'hcbar.clearAll': 'Clear all drawings',
  'hcbar.closeExchanges': 'Close exchange picker',
  'hcbar.closeMenu': 'Close menu',
  'hcbar.cursor': 'Cursor',
  'hcbar.days': 'Days',
  'hcbar.deleteSelected': 'Delete selected',
  'hcbar.labels': 'Labels',
  'hcbar.measureXY': 'Measure XY',
  'hcbar.noExchanges': 'No exchanges found',
  'hcbar.noIndicators': 'No indicators found',
  'hcbar.noResults': 'No results found',
  'hcbar.openTools': 'Open chart tools',
  'hcbar.pressEsc': 'Press {key} to close',
  'hcbar.quote': 'Quote',
  'hcbar.removeAll': 'Remove all',
  'hcbar.removeDrawings': 'Remove drawings',
  'hcbar.requiresHero': 'Requires Hero subscription',
  'hcbar.requiresTier': 'Requires {tier}',
  'hcbar.searchExchange': 'Search exchange…',
  'hcbar.searchSymbol': 'Search symbol, name or exchange…',
  'hcbar.selectExchange': 'Select exchange',
  'hcbar.selectMarket': 'Select market',
  'hcbar.technicals': 'Technicals',
  'hcbar.textLabel': 'Text label',
  'hcbar.weeksMonths': 'Weeks and months',
  'hcbar.activeOne': '{count} active indicator',
  'hcbar.activeOther': '{count} active indicators',
  'hcbar.exchangesOne': '{count} exchange',
  'hcbar.exchangesOther': '{count} exchanges',
  'hcbar.indicatorsOne': '{count} indicator',
  'hcbar.indicatorsOther': '{count} indicators',
  'hcbar.resultsOne': '{count} result',
  'hcbar.resultsOther': '{count} results',
  'hcbar.exchangeName': 'Exchange: {name}',
  'hcbar.marketPair': 'Market: {pair}',
  'hcbar.intervalShort': 'Candle interval: {interval}',
  'hcbar.rangeAll': 'All',
  'indicators.drawingTools': 'Drawing tools',
  'indicators.toolsNote': 'Positions show entry, target, stop and risk:reward. The magnet snaps anchors to a candle’s open, high, low or close.',
  'tool.trendlines': 'Trend lines',
  'tool.rays': 'Rays',
  'tool.fibonacci': 'Fibonacci',
  'tool.channels': 'Channels',
  'tool.rectangles': 'Rectangles',
  'tool.positions': 'Long and short positions',
  'tool.measure': 'Measure',
  'tool.text': 'Text',
  'indicator.bollinger': 'Bollinger Bands',
  'indicator.ichimoku': 'Ichimoku Cloud',

  'ai.title': 'An analyst that draws on your chart',
  'ai.lead': 'Ask in plain language. It loads the live candles, marks levels, zones and trend lines on the chart, and tells you what to watch next.',
  'landing.tools.title': 'Beyond the chart',
  'landing.tools.lead': 'Market data for every coin, buy and sell ratings, trading calculators and the terms explained. All free, no account needed.',
  'landing.faq.title': 'Common questions',
  'landing.faq.more': 'All questions and answers',
  'ai.question': 'Where are BTC’s key levels on the 4h?',
  'ai.chartLabel': 'Live BTC/USDT chart from Binance, four hours per candle, with the example answer’s support, resistance and zones drawn on it',
  'ai.exampleNote': 'Example answer. Its levels are worked out from the live chart each time this page loads.',
  'ai.poweredBy': 'Powered by Claude',
  'ai.fairUse': 'Free questions with a Cryptohopper account',
  'ai.readsWhat': 'Reads price, volume and indicators, not news',
  'ai.analyst': 'AI analyst',
  'ai.failed': 'The live chart did not load from your network, so this example has nothing to read.',
  'ai.levels': 'Levels',
  'ai.watchNext': 'What to watch next',
  'ai.notAdvice': 'Analysis, not financial advice.',
  'ai.tested': 'tested {count} times',
  'ai.rangeHigh': 'Range high {price}',
  'ai.resistance': 'Resistance {price}',
  'ai.support': 'Support {price}',
  'ai.zone': 'Demand zone {bottom} to {top}',
  'ai.zoneShort': 'Demand zone',
  'ai.risingTrend': 'Rising trend line',
  'ai.fallingTrend': 'Falling trend line',
  'ai.fromLow': 'from the {date} low',
  'ai.fromHigh': 'from the {date} high',
  'ai.biasUp': 'BTC is trending up on the 4h. Price holds above a rising 50 EMA, and {r} is the next resistance to clear.',
  'ai.biasDown': 'BTC is under pressure on the 4h. Price trades below a falling 50 EMA, with {s} as the next support to test.',
  'ai.biasRange': 'BTC is ranging on the 4h, between support at {s} and resistance at {r}.',
  'ai.rsiOverbought': 'RSI 14 reads {rsi}, overbought.',
  'ai.rsiOversold': 'RSI 14 reads {rsi}, oversold.',
  'ai.rsiNeutral': 'RSI 14 reads {rsi}, neutral.',
  'ai.closeAboveNext': 'A 4h close above {r} opens the way to {next}.',
  'ai.closeAboveLast': 'A 4h close above {r} clears the last resistance on this chart.',
  'ai.losingSupport': 'Losing {s} puts the demand zone at {bottom} to {top} in play.',
  'ai.closeBelow': 'A 4h close below {s} would weaken the structure.',
  'aiChat.pageLead': 'Ask in plain language. The analysis is drawn on this live chart as it is written.',
  'aiChat.openTerminal': 'Open in terminal',
  'aiChat.chartLabel': 'Chart',
  'aiChat.conversation': 'Conversation',
  'aiChat.intro': 'Ask about the chart and watch the analysis appear on it.',
  'aiChat.introText': 'The analyst loads live data for {ticker}, draws levels, trend lines, zones and trade plans, and explains what to watch next.',
  'aiChat.prompt.levels': 'Where are the key support and resistance levels on {ticker} {tf}?',
  'aiChat.prompt.trend': 'Is {base} trending? Draw the trend lines that matter.',
  'aiChat.prompt.long': 'Plan a long trade on {base} with entry, stop and target.',
  'aiChat.prompt.fib': 'Draw a Fibonacci retracement of the last big move.',
  'aiChat.prompt.indicators': 'What do RSI and MACD say about {base} right now?',
  'aiChat.prompt.compare': 'Compare the daily and 4h picture for {base}.',
  'aiChat.loginTitle': 'Log in to Cryptohopper to use the AI analyst.',
  'aiChat.loginText': 'Every Cryptohopper account gets free questions every day; paid plans get more.',
  'aiChat.login': 'Log in',
  'aiChat.quota': '{left} of {limit} left today · {plan}',
  'aiChat.steps': '{count} steps',
  'aiChat.reading': 'Reading the chart',
  'aiChat.playbook': 'Playbook',
  'aiChat.playbookHint': 'Playbooks: your own analysis method',
  'aiChat.noPlaybook': 'No playbook',
  'aiChat.newPlaybookMenu': 'New playbook…',
  'aiChat.edit': 'Edit',
  'aiChat.editName': 'Edit {name}',
  'aiChat.deleteName': 'Delete {name}',
  'aiChat.editPlaybook': 'Edit playbook',
  'aiChat.newPlaybook': 'New playbook',
  'aiChat.cancel': 'Cancel',
  'aiChat.saveUse': 'Save and use',
  'aiChat.playbookText': 'Teach the analyst your method once. It applies the playbook to every chart and question until you switch it off. Saved in this browser.',
  'aiChat.name': 'Name',
  'aiChat.method': 'Method',
  'aiChat.methodPlaceholder': 'e.g. Use the 4h chart, mark the two nearest supports and resistances, only trade with the EMA 200 trend…',
  'aiChat.fromExample': 'Start from an example',
  'aiChat.defaultName': 'My swing setup',
  'aiChat.newChat': 'New chat',
  'aiChat.newChatHint': 'Start a new conversation',
  'aiChat.upgrade': 'Upgrade',
  'aiChat.placeholder': 'Ask about {ticker}…',
  'aiChat.askLabel': 'Ask the analyst',
  'aiChat.stop': 'Stop',
  'aiChat.send': 'Send',
  'aiChat.footer': 'Uses price, volume and indicators only. Not financial advice.',

  'widgets.title': 'Free widgets for your own site',
  'widgets.lead': 'Twenty-one live widgets, from a full chart to a ticker tape. Paste an iframe or a single line of script into any page.',
  'widgets.tapeLabel': 'Live prices on Binance',
  'widgets.browse': 'Browse the widgets',
  'widgets.pageLead': 'Live charts, prices and market data straight from the exchanges, ready to paste into any page. The strip above is one of them. Pick a widget, set it up and copy the code. No sign-up, no API key.',
  'widget.advancedChart': 'Advanced chart',
  'widget.miniChart': 'Mini chart',
  'widget.tickerTape': 'Ticker tape',
  'widget.singleTicker': 'Single ticker',
  'widget.converter': 'Price converter',
  'widget.exchangePrices': 'Exchange prices',
  'widget.positionCalc': 'Position size calculator',
  'widget.marketOverview': 'Market overview',
  'widget.marketStats': 'Market stats',
  'widget.taGauge': 'Technical analysis gauge',
  'widget.ratings': 'Technical ratings',
  'widget.heatmap': 'Heatmap',
  'widget.correlation': 'Correlation matrix',
  'widget.performance': 'Performance table',
  'widgets.cardMini': 'A coin’s live price, 24h change and a compact chart, for any page.',
  'widgets.cardGauge': 'Buy or sell, summed up from 26 indicators in three gauges.',
  'widgets.cardHeatmap': 'The top 50 coins at a glance, sized by market cap and coloured by the day’s move.',
  'widgets.more': 'And eighteen more',
  'widgets.pick': 'Pick a widget',
  'widgets.cat.label': 'Filter widgets by type',
  'widgets.cat.charts': 'Charts',
  'widgets.cat.prices': 'Prices',
  'widgets.cat.analysis': 'Technical analysis',
  'widgets.cat.market': 'Market data',
  'widgets.setUp': 'Set up the widget: {name}',
  'widgets.setUpLead': 'The preview and the code follow every change.',
  'widgets.selected': 'Selected below',
  'widgets.setItUp': 'Set it up',
  'widgets.tapeTitle': 'Ticker tape widget with live prices',
  'widgets.purpose.advancedChart': 'The full chart with indicators, drawing tools and every timeframe.',
  'widgets.purpose.miniChart': 'Price, 24h change and a compact chart for one coin.',
  'widgets.purpose.tickerTape': 'A scrolling strip of live prices for the top of your page.',
  'widgets.purpose.singleTicker': 'One coin’s live price, 24h change and 24h range.',
  'widgets.purpose.converter': 'Turn any amount of a coin into its quote currency and back, at the live price.',
  'widgets.purpose.exchangePrices': 'One coin’s live price on all six exchanges, with the cheapest and dearest dollar price marked.',
  'widgets.purpose.positionCalc': 'How much to buy or short from a balance, risk per trade, entry and stop-loss. No market data needed.',
  'widgets.purpose.dcaCalc': 'What buying a fixed amount every day, week or month would be worth today, for any market, from its daily closes.',
  'widgets.purpose.marketOverview': 'Top coins, biggest gainers and losers, with 7-day trends.',
  'widgets.purpose.marketStats': 'The total crypto market cap with its 24-hour change, the 24-hour volume and the Bitcoin and Ethereum dominance, from CoinGecko.',
  'widgets.purpose.taGauge': 'Buy and sell signals from 26 indicators, summed up in gauges.',
  'widgets.purpose.ratings': 'Buy and sell ratings for a list of coins at a glance, from the same 26 indicators, with the candlestick pattern on each coin’s last closed candle.',
  'widgets.purpose.patterns': 'The candlestick pattern on the last closed candle of up to twenty coins of your choice, on any interval.',
  'widgets.purpose.correlation': 'How closely up to ten coins of your choice moved together over 30 days, 90 days or a year, from their daily closes.',
  'widgets.purpose.rsiMap': 'Where up to twenty coins of your choice stand on the RSI (14), with the overbought and oversold zones, on any interval.',
  'widgets.purpose.pivots': 'Classic, Fibonacci, Woodie and Camarilla pivot levels for any market, from its last daily, weekly or monthly candle.',
  'widgets.purpose.fibonacci': 'Retracement and extension levels of any market’s swing over the last 30, 90 or 365 days.',
  'widgets.purpose.altseason': 'The altcoin season index: how many of the 50 largest coins beat Bitcoin over the last 90 days, with the best of them.',
  'widgets.purpose.volatility': 'The 7, 30 and 90-day realized volatility of up to ten coins of your choice, from their daily closes.',
  'widgets.purpose.performance': 'The 1W, 1M, 3M, 6M, YTD and 1Y returns of up to ten coins of your choice, from their daily closes.',
  'widgets.purpose.heatmap': 'The top 50 coins, sized by market cap and colored by 24h change.',
  'widgets.art.balance': 'Balance',
  'widgets.art.risk': 'Risk',
  'widgets.art.entry': 'Entry',
  'widgets.art.stop': 'Stop',
  'widgets.tab.top': 'Top coins',
  'widgets.tab.gainers': 'Gainers',
  'widgets.tab.losers': 'Losers',
  'widgets.field.widget': 'Widget',
  'widgets.group.content': 'Content',
  'widgets.group.look': 'Appearance',
  'widgets.group.size': 'Size',
  'widgets.field.symbol': 'Symbol',
  'widgets.field.symbols': 'Symbols',
  'widgets.field.symbolsHint': 'Shown in this order, up to {max}.',
  'widgets.field.interval': 'Interval',
  'widgets.field.range': 'Starting range',
  'widgets.field.tab': 'Starting list',
  'widgets.field.rows': 'Rows',
  'widgets.field.style': 'Chart style',
  'widgets.field.studies': 'Indicators',
  'widgets.field.timezone': 'Time zone',
  'widgets.field.theme': 'Theme',
  'widgets.field.width': 'Width',
  'widgets.field.height': 'Height',
  'widgets.switch.toolbar': 'Show the toolbar',
  'widgets.switch.symbolChange': 'Let visitors change the symbol',
  'widgets.switch.legend': 'Show the price legend',
  'widgets.switch.transparent': 'Transparent background',
  'widgets.theme.dark': 'Dark',
  'widgets.theme.light': 'Light',
  'widgets.size.full': 'Full',
  'widgets.size.fixed': 'Fixed',
  'widgets.size.auto': 'Auto',
  'widgets.options': '{name} options',
  'widgets.previewTitle': '{name} preview',
  'widgets.preview': 'Live preview with real market data',
  'widgets.openTab': 'Open in a new tab',
  'widgets.code.script': 'Script',
  'widgets.code.iframe': 'Iframe',
  'widgets.code.scriptText': 'Recommended. Paste it where the widget should appear; it loads when it scrolls into view.',
  'widgets.code.scriptTextFit': 'Recommended. Paste it where the widget should appear; it loads when it scrolls into view and sizes itself to fit.',
  'widgets.code.iframeText': 'For site builders that only accept an iframe. Its height stays as set.',
  'widgets.code.label': '{title} embed code',
  'widgets.copy': 'Copy',
  'widgets.copied': 'Copied',
  'widgets.copiedScript': 'Script code copied',
  'widgets.copiedIframe': 'Iframe code copied',
  'widgets.copyBlocked': 'Copying is blocked in this browser',
  'widgets.copyBlockedText': 'Select the code and press Ctrl+C (or ⌘C).',
  'widgets.chooseSymbol': 'Choose a symbol',
  'widgets.addSymbolTitle': 'Add a symbol',
  'widgets.addSymbol': 'Add symbol',
  'widgets.remove': 'Remove {name}',
  'widgets.addIndicator': 'Add indicator',
  'widgets.searchIndicators': 'Search indicators',
  'widgets.noIndicator': 'No indicator matches “{query}”.',
  'widgets.unreachable': '{symbol} (exchange not reachable)',
  'widgets.notFound': '{symbol} (not found)',
  'widgets.faqTitle': 'Questions about the widgets',
  'widgets.faq.free.q': 'Are the widgets free?',
  'widgets.faq.free.a': 'Yes. Every widget is free to use on any website, with no sign-up or API key. The market data comes straight from the exchanges’ public APIs in your visitors’ browsers.',
  'widgets.faq.add.q': 'How do I add a widget to my website?',
  'widgets.faq.add.a': 'Pick a widget above, set it up and copy the code. The script snippet is a few lines of HTML: paste it where the widget should appear, and it sizes itself to its content. The iframe snippet is for site builders that only accept an iframe; its height stays as you set it.',
  'widgets.faq.builders.q': 'Does it work with my site builder?',
  'widgets.faq.builders.a': 'Any site builder or CMS that lets you add custom HTML or an embed block can show the widgets: paste the code into that block. If it only accepts iframes, use the iframe snippet.',
  'widgets.faq.speed.q': 'Will a widget slow down my page?',
  'widgets.faq.speed.a': 'The loader script is about 2 KB compressed, and each widget runs in its own frame that loads when it scrolls into view, so it does not hold up the rest of your page.',
  'widgets.faq.look.q': 'Can I change how a widget looks?',
  'widgets.faq.look.a': 'Yes: pick a dark or light theme, a transparent background that takes on your page’s colours, the width and height, and per widget the coins, interval or period. The text inside the widgets is in English.',

  'closing.title': 'The full terminal is one click away.',
  'closing.lead': 'Free, no account, nothing to install.',
  'closing.bot': 'Found a setup that works? {link}.',
  'closing.botLink': 'Automate it with a Cryptohopper trading bot',

  // Page titles, descriptions and headings; also used for the prerendered HTML (src/seo/pages.ts).
  'page.chart.title': 'Crypto chart terminal: live charts, 38 indicators and drawing tools · Cryptohopper Charts',
  'page.chart.description': 'Free advanced crypto chart terminal: multi-chart layouts, 38 indicators, drawing tools, alerts, a Backtest Lab and an AI chart analyst.',
  'page.chart.heading': 'Crypto chart terminal',
  'page.markets.title': 'Crypto markets: prices, movers and heatmap · Cryptohopper Charts',
  'page.markets.description': 'Live crypto prices and market caps for the top 500 coins, a pair screener for Binance, Coinbase, Kraken, Bybit, OKX and Bitvavo, the biggest movers of the day, a market heatmap and a correlation matrix of popular coins.',
  'page.markets.heading': 'Crypto markets',
  'page.mtab.screener.heading': 'Crypto pair screener',
  'page.mtab.screener.title': 'Crypto pair screener: filter every pair on six exchanges · Cryptohopper Charts',
  'page.mtab.screener.description': 'Screen the spot pairs of Binance, Coinbase, Kraken, Bybit, OKX and Bitvavo by quote currency and 24-hour volume, with live prices, 24h change, highs and lows. Free, no account.',
  'page.mtab.movers.heading': 'Top crypto gainers and losers',
  'page.mtab.movers.title': 'Top crypto gainers and losers today · Cryptohopper Charts',
  'page.mtab.movers.description': 'The biggest gainers, losers and most traded coins of the last 24 hours on Binance, live, with at least $2M in volume. Stablecoins and leveraged tokens are left out.',
  'page.mtab.performance.heading': 'Crypto performance',
  'page.mtab.performance.title': 'Crypto performance: 1W, 1M, 3M, 6M, YTD and 1Y returns · Cryptohopper Charts',
  'page.mtab.performance.description': 'How 30 popular coins have performed over 1 week, 1 month, 3 months, 6 months, the year to date and 1 year, from Binance daily closes. Sort by any period.',
  'page.mtab.volatility.heading': 'Crypto volatility',
  'page.mtab.volatility.title': 'Crypto volatility: 7, 30 and 90-day realized volatility of popular coins · Cryptohopper Charts',
  'page.mtab.volatility.description': 'Annualized realized volatility of 30 popular coins over 7, 30 and 90 days, from Binance daily closes. See which coins swing most and least, and sort by any period.',
  'page.mtab.altseason.heading': 'Altcoin season index',
  'page.mtab.altseason.title': 'Altcoin season index: are altcoins beating Bitcoin? · Cryptohopper Charts',
  'page.mtab.altseason.description': 'Live altcoin season index: how many of the 50 largest coins rose more than Bitcoin over the last 90 days, with each coin’s 90-day change next to Bitcoin’s. 75 or more is altcoin season, 25 or less is Bitcoin season.',
  'page.mtab.heatmap.heading': 'Crypto heatmap',
  'page.mtab.heatmap.title': 'Crypto heatmap: the market by market cap and 24h change · Cryptohopper Charts',
  'page.mtab.heatmap.description': 'A live heatmap of the top 100 coins: each tile is sized by market cap and coloured by the 24-hour price change. Open any coin on the chart.',
  'page.mtab.compare.heading': 'Crypto prices across exchanges',
  'page.mtab.compare.title': 'Crypto prices compared across exchanges · Cryptohopper Charts',
  'page.mtab.compare.description': 'The price of the largest coins on Binance, Coinbase, Kraken, Bybit, OKX and Bitvavo side by side, in dollars or euros, with the cheapest and most expensive exchange and the spread.',
  'page.mtab.correlation.heading': 'Crypto correlation matrix',
  'page.mtab.correlation.title': 'Crypto correlation matrix: how coins move together · Cryptohopper Charts',
  'page.mtab.correlation.description': 'How closely the daily returns of 15 popular coins moved together over the last 30 days, 90 days or year, from Binance daily closes. Free and updated daily.',
  'page.ai.title': 'AI chart analyst: ask a question, see it drawn on the chart · Cryptohopper Charts',
  'page.ai.description': 'Ask about any crypto chart in plain language. The AI analyst loads live data, draws support, resistance, trend lines and trade plans on the chart and explains what to watch next. Free questions with a Cryptohopper account.',
  'page.ai.heading': 'AI chart analyst',
  'page.widgets.title': 'Free crypto chart widgets for your website · Cryptohopper Charts',
  'page.widgets.description': 'Add free, live crypto widgets to any website: advanced charts, mini charts, ticker tapes, price converters, exchange price comparisons, a position size calculator, a DCA calculator, market overviews, technical analysis gauges, technical ratings for a list of coins, a correlation matrix, a performance table, an RSI map, pivot points, an altcoin season index, a volatility table, a candlestick pattern list, Fibonacci retracement levels, global market stats and a crypto heatmap. Set one up and copy the code. No sign-up, no API key.',
  'page.widgets.heading': 'Free crypto chart widgets for your website',
  'seo.factFree': 'The charts, markets and widgets are free, with no account and nothing to install.',
  'seo.factExchanges': 'Live prices and candles straight from Binance, Coinbase, Kraken, Bybit, OKX and Bitvavo.',
  'seo.factTools': '38 technical indicators, drawing tools and up to 8 synced charts per window.',
  'seo.factAi': 'An AI chart analyst, powered by Claude, that draws support, resistance and trend lines on the chart; log in with a free Cryptohopper account to use it.',
  'seo.factWidgets': 'Free embeddable widgets: charts, ticker tapes, market overviews, a technical analysis gauge, technical ratings and a heatmap.',
  'seo.factBacktest': 'A Backtest Lab in the chart terminal: test seven ready-made strategies, or one the AI analyst writes, on the chart’s own history.',
  'seo.pages': 'Pages',
  'seo.madeBy': 'Cryptohopper Charts is made by {link}, the crypto trading bot platform founded in Amsterdam in 2017.',

  // Support / FAQ page (src/pages/SupportPage.tsx, src/features/support/faq.ts).
  'nav.support': 'Support',
  'page.support.title': 'Help and FAQ: free crypto charts, data, AI analyst and widgets · Cryptohopper Charts',
  'page.support.description': 'Answers to common questions about Cryptohopper Charts: is it free, where the data comes from, saving and sharing layouts, price alerts, the AI analyst and widgets. For account or bot help, go to Cryptohopper Support.',
  'page.support.heading': 'Help and FAQ',
  'support.lead': 'Answers about the charts, the market data, the AI analyst and the widgets. For your Cryptohopper account, subscription or trading bots, Cryptohopper Support can help.',
  'support.ctaTitle': 'Need help with your Cryptohopper account or bots?',
  'support.ctaText': 'Cryptohopper Support has guides and articles about accounts, subscriptions and trading bots.',
  'support.ctaButton': 'Go to Cryptohopper Support',
  'support.topics': 'Topics',
  'support.groupStart': 'Getting started',
  'support.groupCharts': 'Charts and tools',
  'support.groupData': 'Market data and exchanges',
  'support.groupAi': 'AI analyst',
  'support.groupWidgets': 'Widgets',
  'support.groupPrivacy': 'Privacy',
  'faq.free.q': 'Is Cryptohopper Charts free?',
  'faq.free.a': 'Yes. The charts, markets and widgets are free to use, without an account and without installing anything. The AI analyst needs a Cryptohopper login: a free account includes a daily and a monthly question allowance, and a subscription includes more.',
  'faq.account.q': 'Do I need an account?',
  'faq.account.a': 'Not for the charts, markets and widgets. They run in your browser, and your layouts, watchlists, alerts and settings are saved in that browser, so they stay on this device. To ask the AI analyst, log in with a Cryptohopper account; a free one is enough.',
  'faq.trading.q': 'Can I place trades from the charts?',
  'faq.trading.a': 'No. Cryptohopper Charts is for charting and analysis and never places orders. To automate a strategy, use a Cryptohopper trading bot.',
  'faq.mobile.q': 'Does it work on my phone?',
  'faq.mobile.a': 'Yes. The site and the chart terminal work on phones and tablets; on a small screen the terminal has its own toolbar.',
  'faq.tools.q': 'Which indicators and drawing tools are there?',
  'faq.tools.a': '38 indicators, from moving averages, RSI and MACD to Bollinger Bands, Ichimoku and Supertrend, and drawing tools for trend lines, rays, Fibonacci, channels, rectangles, long and short positions, measuring and text.',
  'faq.layouts.q': 'How do I save and share a layout?',
  'faq.layouts.a': 'Layouts are saved in your browser; Ctrl + S saves the current one. A share link sends a layout, drawings included, as a single link. Whoever opens it gets a copy, and their own layout is kept as a backup.',
  'faq.alerts.q': 'How do price alerts work?',
  'faq.alerts.a': 'Set an alert for a price crossing, rising above or falling below a level. When it triggers you get a browser notification. Alerts only run while a Cryptohopper Charts tab is open.',
  'faq.backtest.q': 'Can I backtest a trading strategy?',
  'faq.backtest.a': 'Yes. Open Backtest in the chart terminal, pick one of seven ready-made strategies (EMA cross, RSI dip, Bollinger reversion, MACD trend, Donchian breakout, SuperTrend and a trend-filtered dip), set its inputs and run it on the active chart. You get the return against buy and hold, maximum drawdown, win rate, profit factor, Sharpe ratio and fees, with every trade marked on the chart. It runs in your browser with no account; the AI analyst can also write a strategy for you to test, which needs a Cryptohopper login. Backtests simulate the past and are not financial advice.',
  'faq.data.q': 'Where does the market data come from?',
  'faq.data.a': 'Prices and candles stream straight from the public APIs of Binance, Coinbase, Kraken, Bybit, OKX and Bitvavo, in your browser. Coin names, logos and market caps come from CoinGecko.',
  'faq.blocked.q': 'Why is one of the exchanges not loading?',
  'faq.blocked.a': 'Some exchanges block certain countries or networks; Bybit and OKX, for example, are not reachable from the US. The other exchanges keep working.',
  'faq.ai.q': 'What does the AI analyst do?',
  'faq.ai.a': 'Ask about any chart in plain language. It loads the live candles, draws support, resistance, zones and trend lines on the chart and explains what to watch next. It reads price, volume and indicators, not news, and its answers are analysis, not financial advice.',
  'faq.aiLimit.q': 'Is there a limit on AI questions?',
  'faq.aiLimit.a': 'Yes, it depends on your Cryptohopper plan. A free account has both a daily and a monthly question allowance, while a subscription includes more. If you reach your limit, try again later or upgrade your plan.',
  'faq.widgets.q': 'How do I add a widget to my website?',
  'faq.widgets.a': 'Open Widgets, pick one, set the market, size and colours, and copy the code: an iframe or a single line of script. No sign-up or API key is needed.',
  'faq.privacy.q': 'What does the site store about me?',
  'faq.privacy.a': 'The charts need no account. Layouts, watchlists, alerts and settings are stored in your browser, and your language choice in a cookie shared with www.cryptohopper.com. When you use the AI analyst, your Cryptohopper login is checked with www.cryptohopper.com to see your plan. For the AI limits, your Cryptohopper user ID and keyed IP hashes are stored in short-lived usage counters for up to about a month, and the login check result is kept for a few minutes. The login cookie itself is never stored.',

  // Footer columns (components/SiteHeader.tsx).
  'footer.tagline': 'Free crypto charts, live market data, an AI chart analyst and widgets, made by Cryptohopper, the trading bot platform founded in Amsterdam in 2017.',
  'footer.follow': 'Follow Cryptohopper',
  'footer.colProduct': 'Charts',
  'footer.colResources': 'Resources',
  'footer.colCryptohopper': 'Cryptohopper',
  'footer.colLegal': 'Legal',
  'footer.bots': 'Trading bots',
  'footer.pricing': 'Pricing',
  'footer.marketplace': 'Marketplace',
  'footer.support': 'Cryptohopper Support',
  'footer.privacy': 'Privacy',

  // Markets page and shared table parts (pages/MarketsPage.tsx, features/markets/).
  'common.tryAgain': 'Try again',
  'common.clearSearch': 'Clear search',
  'common.showing': 'Showing {shown} of {total}',
  'common.showMore': 'Show {count} more',
  'common.updated': 'Updated {time}',
  'common.refresh': 'Refresh',
  'markets.lead': 'Prices for the top 500 coins, a pair screener for six exchanges, the day’s biggest movers and a market heatmap. Open any coin on the chart.',
  'markets.tabsLabel': 'Market views',
  'markets.tab.coins': 'Coins',
  'markets.tab.screener': 'Screener',
  'markets.tab.movers': 'Movers',
  'markets.tab.heatmap': 'Heatmap',
  'markets.totalsUnavailable': 'Market totals are unavailable right now.',
  'markets.totalCap': 'Total market cap',
  'markets.volume24h': '24h volume',
  'markets.btcDominance': 'BTC dominance',
  'markets.ethDominance': 'ETH dominance',
  'markets.coins.one': '{count} coin',
  'markets.coins.other': '{count} coins',
  'markets.pairs.one': '{count} pair',
  'markets.pairs.other': '{count} pairs',
  'markets.coinsError': 'Coin prices could not be loaded',
  'markets.coinGeckoLimited': 'CoinGecko may be limiting requests from your network. Wait a minute, then try again.',
  'markets.searchCoins': 'Search coins',
  'markets.searchCoinsPlaceholder': 'Search by name or ticker',
  'markets.topCoins': 'Top {count} coins by market cap',
  'markets.loadingCoins': 'Loading coins',
  'markets.pricesFrom': 'Prices from CoinGecko',
  'markets.noCoinsMatch': 'No coins match “{query}”',
  'markets.noCoinsHint': 'Search by name or ticker, for example Solana or SOL. Only the top {count} coins by market cap are listed.',
  'markets.noChart': 'No chart for this coin yet',
  'markets.col.coin': 'Coin',
  'markets.col.price': 'Price',
  'markets.col.7d': '7d',
  'markets.col.last7d': 'Last 7 days',
  'markets.col.marketCap': 'Market cap',
  'markets.col.volume24h': 'Volume (24h)',
  'markets.col.volume': 'Volume',
  'markets.col.pair': 'Pair',
  'markets.col.lastPrice': 'Last price',
  'markets.col.high24h': '24h high',
  'markets.col.low24h': '24h low',
  'markets.anyVolume': 'Any volume',
  'markets.volumeOver': 'Volume over {amount}',
  'markets.exchange': 'Exchange',
  'markets.quoteCurrency': 'Quote currency',
  'markets.minVolume': 'Minimum 24h volume',
  'markets.searchPairs': 'Search pairs',
  'markets.pairsOn.one': '{count} {quote} pair on {exchange}',
  'markets.pairsOn.other': '{count} {quote} pairs on {exchange}',
  'markets.unreachable': '{exchange} could not be reached',
  'markets.showInstead': 'Show {exchange} instead',
  'markets.unreachableBody': 'Some exchanges block visitors from certain countries or networks, and public APIs go down now and then. Try again in a moment, or pick another exchange.',
  'markets.noQuotePairs': '{exchange} has no {quote} pairs right now',
  'markets.noPairsMatch': 'No {quote} pairs match these filters',
  'markets.clearFilters': 'Clear filters',
  'markets.pickQuote': 'Pick another quote currency above.',
  'markets.lowerVolume': 'Lower the minimum volume or change the search.',
  'markets.openCoinbaseScreener': 'Open the Coinbase screener',
  'markets.moversUnreachableBody': 'Movers are ranked from Binance’s USDT markets, and Binance blocks some countries and networks. The screener can show Coinbase, Kraken and other exchanges instead.',
  'markets.moversNote': 'Binance spot pairs against USDT with at least $2M traded in the last 24 hours. Stablecoins and leveraged tokens are left out.',
  'markets.topGainers': 'Top gainers',
  'markets.topLosers': 'Top losers',
  'markets.mostTraded': 'Most traded',
  'markets.noGainers': 'No pair is up over the last 24 hours.',
  'markets.noLosers': 'No pair is down over the last 24 hours.',
  'markets.noTraded': 'No pair traded more than $2M in the last 24 hours.',
  'markets.heatmapError': 'The heatmap could not be loaded',
  'markets.heatmapLimited': 'Market caps come from CoinGecko, which may be limiting requests from your network. Wait a minute, then try again.',
  'markets.heatmapNote': 'Top {count} coins by market cap. Tile size is market cap, colour is the 24h price change.',
  'markets.showAsTable': 'Show as a table',
  'markets.heatmapLabel': 'Top {count} coins by market cap, coloured by 24h change',
  'markets.tileLabel': '{name}, {change} in 24 hours, market cap {cap}',
  'markets.change24h': '24h change',
  'markets.rank': 'Rank',
  'markets.legendLabel': 'Colour scale for the 24h change: red for falls, grey around 0%, green for gains, strongest at {clamp}% or more either way',
  'markets.tab.compare': 'Compare',
  'markets.compareNote': 'The {count} largest coins by market cap that two or more exchanges list in this currency, priced on each of them. The cheapest price is green, the most expensive red, and the spread is how much more the most expensive exchange asks. USDT prices are converted to dollars at the live USDT/USD rate; markets with less than 10,000 traded in 24 hours are left out.',
  'markets.compareUnreachable': 'Fewer than two exchanges could be reached, so there is nothing to compare',
  'markets.currency': 'Currency',
  'markets.currencyUsd': 'US dollar (USD and USDT)',
  'markets.currencyEur': 'Euro (EUR)',
  'markets.col.cheapest': 'Cheapest',
  'markets.col.dearest': 'Most expensive',
  'markets.col.spread': 'Spread',
  'markets.tab.correlation': 'Correlation',
  'markets.corrNote': 'How closely the daily returns of 15 popular coins moved together, from Binance’s daily closes against USDT. 1 means they moved in step, 0 means no relation and −1 means opposite moves.',
  'markets.corrPeriod': 'Period',
  'markets.corr30': 'Last 30 days',
  'markets.corr90': 'Last 90 days',
  'markets.corr365': 'Last year',
  'markets.corrCell': '{a} and {b}: {value}',
  'markets.corrLabel': 'Correlation of daily returns',
  'markets.corrUnreachable': 'The correlations are worked out from Binance’s daily prices, and Binance blocks some countries and networks. Try again in a moment.',
  'markets.corr.faqTitle': 'Questions about crypto correlation',
  'markets.corr.faq.what.q': 'What does the correlation number mean?',
  'markets.corr.faq.what.a': 'How closely two coins’ daily returns moved together, from −1 to 1. Near 1 they rose and fell on the same days, near 0 there was no relation, and below 0 they tended to move in opposite directions.',
  'markets.corr.faq.how.q': 'How is it calculated here?',
  'markets.corr.faq.how.a': 'The Pearson correlation of daily log returns from Binance daily closes against USDT, over the last 30 days, 90 days or year, using only the days on which both coins have a return.',
  'markets.corr.faq.use.q': 'Why does it matter for a portfolio?',
  'markets.corr.faq.use.a': 'Coins that are highly correlated tend to fall together, so holding several of them spreads risk less than it seems. Correlations change over time, which is why the matrix can be shown for different periods.',
  'markets.tab.performance': 'Performance',
  'markets.perfNote': 'Price change of 30 popular coins over each period, from Binance’s daily closes against USDT up to the last completed day. Click a column to sort.',
  'markets.perf.faqTitle': 'Questions about performance',
  'markets.perf.faq.calc.q': 'How is each period’s performance worked out?',
  'markets.perf.faq.calc.a': 'From Binance’s daily closes against USDT: the change from the close on the day the period starts (or the last close before it) to the last completed day. One week is 7 days, one month 30, three months 90, six months 180 and one year 365; the year to date starts at the last close of the previous year.',
  'markets.perf.faq.dash.q': 'Why does a coin show a dash for a period?',
  'markets.perf.faq.dash.a': 'Its Binance history does not reach back that far, usually because the coin was listed after the period started.',
  'markets.perf.faq.coins.q': 'Which coins are in the table?',
  'markets.perf.faq.coins.a': 'The 30 popular coins that have their own chart page on this site, such as Bitcoin, Ethereum and Solana. Click a column to sort them by that period.',
  'markets.heat.faqTitle': 'Questions about the heatmap',
  'markets.heat.faq.tiles.q': 'What do the size and colour of a tile mean?',
  'markets.heat.faq.tiles.a': 'The size is the coin’s market cap and the colour its price change over the last 24 hours: green for a rise, red for a fall and grey around zero. A move of 8% or more either way gets the strongest colour.',
  'markets.heat.faq.coins.q': 'Which coins are on the heatmap?',
  'markets.heat.faq.coins.a': 'The 100 largest coins by market cap, from CoinGecko. Click a tile to open the coin on the chart when it trades on one of the six exchanges here.',
  'markets.heat.faq.update.q': 'How often does the heatmap update?',
  'markets.heat.faq.update.a': 'Prices and market caps are fetched again from CoinGecko every five minutes while the page is open.',
  'markets.mov.faqTitle': 'Questions about the movers',
  'markets.mov.faq.how.q': 'How are the top gainers and losers picked?',
  'markets.mov.faq.how.a': 'From Binance spot pairs against USDT: the 15 coins with the biggest rise and the 15 with the biggest fall over the last 24 hours, plus the 15 with the most volume traded. Only pairs with at least $2M traded in 24 hours count, so thin markets cannot top the lists.',
  'markets.mov.faq.left.q': 'Why are some coins left out?',
  'markets.mov.faq.left.a': 'Stablecoins and fiat currencies barely move against USDT, leveraged tokens such as BTCUP move several times the market by design, and tokenized stocks are not crypto, so the lists leave all three out.',
  'markets.mov.faq.update.q': 'How often do the lists update?',
  'markets.mov.faq.update.a': 'The 24-hour figures are fetched again from Binance every minute while the page is open. Click a coin to open it on the chart.',
  'markets.scr.faqTitle': 'Questions about the screener',
  'markets.scr.faq.pairs.q': 'Which exchanges and pairs does the screener show?',
  'markets.scr.faq.pairs.a': 'The spot pairs that Binance, Coinbase, Kraken, Bybit, OKX or Bitvavo lists against the quote currency you pick, such as USDT, USD, EUR or BTC. Choose the exchange and quote currency above the table.',
  'markets.scr.faq.filter.q': 'How do I narrow the list down?',
  'markets.scr.faq.filter.a': 'Search by pair or coin name, set a minimum 24-hour volume to hide thin markets, and click a column header to sort by price, 24-hour change, high, low or volume. The table starts with the highest volume and shows 100 pairs at a time.',
  'markets.scr.faq.data.q': 'Where do the prices come from?',
  'markets.scr.faq.data.a': 'From each exchange’s public market data, fetched again every minute while the page is open. The change, high, low and volume cover the last 24 hours. Click a pair to open it on the chart.',
  'markets.perfClose': 'Daily close',
  'markets.perf.1w': '1W',
  'markets.perf.1m': '1M',
  'markets.perf.3m': '3M',
  'markets.perf.6m': '6M',
  'markets.perf.ytd': 'YTD',
  'markets.perf.1y': '1Y',
  'markets.perfUnreachable': 'The returns are worked out from Binance’s daily prices, and Binance blocks some countries and networks. Try again in a moment.',
  'markets.tab.volatility': 'Volatility',
  'markets.volNote': 'Annualized realized volatility of 30 popular coins: how much their daily returns varied over the last 7, 30 and 90 days, from Binance daily closes against USDT, scaled to a year. Higher means bigger daily swings. Click a column to sort.',
  'markets.vol.7d': '7 days',
  'markets.vol.30d': '30 days',
  'markets.vol.90d': '90 days',
  'markets.volUnreachable': 'Volatility is worked out from Binance’s daily prices, and Binance blocks some countries and networks. Try again in a moment.',
  'markets.vol.faqTitle': 'Questions about crypto volatility',
  'markets.vol.faq.what.q': 'What is realized volatility?',
  'markets.vol.faq.what.a': 'A measure of how much a price has actually moved: the standard deviation of its daily returns over a period, scaled to a year so periods and coins can be compared. A coin at 80% has swung about twice as much from day to day as one at 40%.',
  'markets.vol.faq.how.q': 'How is it calculated here?',
  'markets.vol.faq.how.a': 'From Binance daily closes against USDT: the daily log returns over the last 7, 30 or 90 days, their sample standard deviation, times the square root of 365 because crypto trades every day.',
  'markets.vol.faq.use.q': 'How do traders use it?',
  'markets.vol.faq.use.a': 'To size positions and place stops: the more a coin moves, the smaller the position for the same risk and the wider the stop it may need. It describes past moves, not their direction or what comes next.',
  'markets.tab.altseason': 'Altseason',
  'markets.altNote': 'The share of the 50 largest coins by market cap that rose more than Bitcoin over the last 90 days, from Binance daily closes against USDT. Stablecoins, wrapped and staked tokens and tokenized assets are left out, as are coins with less than 90 days of history. 75 or more is altcoin season, 25 or less is Bitcoin season.',
  'markets.alt.indexLabel': 'Altcoin season index',
  'markets.alt.altcoin': 'Altcoin season',
  'markets.alt.bitcoin': 'Bitcoin season',
  'markets.alt.neutral': 'Neither season',
  'markets.alt.summary': '{beat} of {total} coins rose more than Bitcoin ({btc}) over 90 days.',
  'markets.alt.progress': '{done} of {total} coins loaded',
  'markets.alt.change': '90-day change, with Bitcoin among them',
  'markets.altUnreachable': 'The index is worked out from Binance’s daily prices, and Binance blocks some countries and networks. Try again in a moment.',
  'markets.alt.faqTitle': 'Questions about the altcoin season index',
  'markets.alt.faq.what.q': 'What is the altcoin season index?',
  'markets.alt.faq.what.a': 'A number from 0 to 100 that says how many of the 50 largest coins did better than Bitcoin over the last 90 days. 75 or more is called altcoin season, 25 or less Bitcoin season, and anything in between neither.',
  'markets.alt.faq.how.q': 'How is it calculated here?',
  'markets.alt.faq.how.a': 'From Binance daily closes against USDT: each coin’s price change over the last 90 days, to the last completed day, is compared with Bitcoin’s, and the index is the share of coins that rose more. Stablecoins, wrapped and staked tokens, gold-backed tokens and tokenized assets are left out, as are coins with less than 90 days of history.',
  'markets.alt.faq.use.q': 'What does it tell a trader?',
  'markets.alt.faq.use.a': 'Whether the largest altcoins or Bitcoin have led the market. A high reading means most of them outperformed Bitcoin over the last 90 days; a low one means Bitcoin did better. It describes the past 90 days, not what comes next.',
  'markets.alt.faq.update.q': 'How often is it updated?',
  'markets.alt.faq.update.a': 'It is worked out in your browser each time you open the page, from daily closes up to the last completed day, with the current list of the largest coins by market cap.',

  // Signals page (features/signals/).
  'nav.signals': 'Signals',
  'page.signals.title': 'Crypto signals: buy and sell ratings from technical analysis · Cryptohopper Charts',
  'page.signals.description': 'Technical buy and sell ratings for the 50 most-traded coins on Binance, from 26 oscillators and moving averages, on intervals from 15 minutes to 1 week, with each coin’s RSI and which coins are overbought or oversold. Free and updated live.',
  'page.signals.heading': 'Crypto signals',
  'signals.lead': 'Buy and sell ratings for the 50 most-traded coins, worked out from 26 indicators: 11 oscillators such as RSI, MACD and Stochastic, and 15 moving averages from 10 to 200 periods.',
  'signals.interval': 'Interval',
  'signals.filter': 'Rating',
  'signals.all': 'All',
  'signals.rating.strongBuy': 'Strong buy',
  'signals.rating.buy': 'Buy',
  'signals.rating.neutral': 'Neutral',
  'signals.rating.sell': 'Sell',
  'signals.rating.strongSell': 'Strong sell',
  'signals.notEnough': 'Not enough data',
  'signals.noData': 'No data',
  'signals.col.oscillators': 'Oscillators',
  'signals.col.ma': 'Moving averages',
  'signals.col.pattern': 'Pattern',
  'signals.clearFilters': 'Clear filters',
  'signals.col.summary': 'Summary',
  'signals.search': 'Search by ticker or name',
  'signals.progress': 'Rated {done} of {total} coins',
  'signals.noMatch': 'No coins match',
  'signals.noMatchHint': 'Pick another rating or interval, or change the search.',
  'signals.note': 'The most-traded Binance spot pairs against USDT, with at least $2M traded in the last 24 hours, among the top 500 coins by market cap; stablecoins, leveraged tokens and tokenized stocks are left out. Ratings refresh every 5 minutes.',
  'signals.disclaimer': 'Indicator summaries, not financial advice. A rating describes what the indicators say now, not what the price will do next.',
  'signals.patterns.title': 'Candlestick patterns',
  'signals.patterns.lead': 'Patterns on each coin’s last closed {interval} candle. Reversal patterns count only after a matching trend over the 10 candles before them.',
  'signals.patterns.filterHint': 'Pick a group to show only those coins in the table.',
  'signals.patterns.bullish': 'Bullish',
  'signals.patterns.bearish': 'Bearish',
  'signals.patterns.neutral': 'Indecision',
  'signals.patterns.none': 'None on the last candle',
  'signals.patterns.explain': 'What the patterns mean',
  'signals.pattern.threeWhiteSoldiers': 'Three white soldiers',
  'signals.pattern.threeWhiteSoldiers.desc': 'Three long rising candles in a row, each opening inside the previous body and closing higher.',
  'signals.pattern.threeBlackCrows': 'Three black crows',
  'signals.pattern.threeBlackCrows.desc': 'Three long falling candles in a row, each opening inside the previous body and closing lower.',
  'signals.pattern.morningStar': 'Morning star',
  'signals.pattern.morningStar.desc': 'After a decline: a long falling candle, a small one, then a rising candle that closes above the middle of the first.',
  'signals.pattern.eveningStar': 'Evening star',
  'signals.pattern.eveningStar.desc': 'After a rise: a long rising candle, a small one, then a falling candle that closes below the middle of the first.',
  'signals.pattern.bullishEngulfing': 'Bullish engulfing',
  'signals.pattern.bullishEngulfing.desc': 'After a decline, a rising candle whose body covers the whole body of the falling candle before it.',
  'signals.pattern.bearishEngulfing': 'Bearish engulfing',
  'signals.pattern.bearishEngulfing.desc': 'After a rise, a falling candle whose body covers the whole body of the rising candle before it.',
  'signals.pattern.hammer': 'Hammer',
  'signals.pattern.hammer.desc': 'After a decline, a small body near the top with a lower wick at least twice the body: sellers pushed the price down, buyers pushed it back.',
  'signals.pattern.hangingMan': 'Hanging man',
  'signals.pattern.hangingMan.desc': 'The hammer shape after a rise: a warning that selling pressure is appearing.',
  'signals.pattern.invertedHammer': 'Inverted hammer',
  'signals.pattern.invertedHammer.desc': 'After a decline, a small body near the bottom with an upper wick at least twice the body.',
  'signals.pattern.shootingStar': 'Shooting star',
  'signals.pattern.shootingStar.desc': 'The inverted hammer shape after a rise: buyers pushed the price up, sellers pushed it back down.',
  'signals.pattern.doji': 'Doji',
  'signals.pattern.doji.desc': 'Open and close almost equal (a body of at most a tenth of the range): buyers and sellers in balance.',
  'signals.howTitle': 'How the rating works',
  'signals.howVotes': 'On the latest candle every indicator votes buy, sell or neutral. The 11 oscillators are RSI, Stochastic, CCI, ADX, Awesome oscillator, Momentum, MACD, Stochastic RSI, Williams %R, Bull bear power and the Ultimate oscillator. The 15 moving averages are the EMA and SMA of 10, 20, 30, 50, 100 and 200 periods, the Ichimoku base line, VWMA (20) and HMA (9).',
  'signals.howScore': 'Each group scores the average of its votes, from −1 to 1, and the summary is the average of the two groups. Below −0.5 is Strong sell, up to −0.1 Sell, up to 0.1 Neutral, up to 0.5 Buy and above that Strong buy, as on TradingView.',
  'signals.openChart': 'Open {pair} on the chart',
  'signals.unreachableBody': 'Signals are worked out from Binance’s USDT markets, and Binance blocks some countries and networks. Try again in a moment.',
  'signals.rsiTitle': 'RSI map',
  'signals.rsiNote': 'The RSI (14) of each coin on the {interval} chart, in table order. 70 and above is overbought, 30 and below oversold.',
  'signals.overbought': 'Overbought',
  'signals.oversold': 'Oversold',
  'signals.rsiDot': '{base}: RSI {value}',
  'signals.faqTitle': 'Questions about the signals',
  'signals.faq.rating.q': 'What do Strong buy and Strong sell mean?',
  'signals.faq.rating.a': 'The summary score is the average of the oscillator and moving-average scores, from −1 to 1. Above 0.5 is Strong buy and below −0.5 is Strong sell: most of the 26 indicators agree on the latest candle. A rating describes what the indicators say now, not where the price goes next.',
  'signals.faq.rsi.q': 'What is RSI, and when is a coin overbought or oversold?',
  'signals.faq.rsi.a': 'The Relative Strength Index (14) compares the size of recent gains with recent losses on a scale from 0 to 100. A reading of 70 or more is usually called overbought, 30 or less oversold. The RSI map on this page shows where each of the 50 coins stands on the chosen interval.',
  'signals.faq.patterns.q': 'Which candlestick patterns does the page find?',
  'signals.faq.patterns.a': 'Eleven classic patterns on each coin’s last closed candle at the chosen interval: three white soldiers, three black crows, morning and evening star, bullish and bearish engulfing, hammer, hanging man, inverted hammer, shooting star and doji. Reversal patterns count only after a matching trend over the 10 candles before them, so a hammer needs a decline and a hanging man a rise. A pattern is a hint, not a forecast: check it against the trend and the ratings above.',
  'signals.faq.coverage.q': 'Which coins and intervals are covered?',
  'signals.faq.coverage.a': 'The 50 most-traded Binance spot pairs against USDT with at least $2M traded in 24 hours, among the top 500 coins by market cap, on the 15-minute, 1-hour, 4-hour, daily and weekly charts. Ratings refresh every 5 minutes.',
  'signals.faq.bots.q': 'Can I trade these signals automatically?',
  'signals.faq.bots.a': 'Not from this page: it only shows ratings and never places orders. With a Cryptohopper trading bot you design a strategy from 130+ indicators and candle patterns, without code, and the bot trades it for you.',

  // Coin chart pages (/chart/btc-usdt…, src/seo/coins.ts).
  'coin.title': '{name} ({base}/USDT) chart: live price, indicators and drawing tools · Cryptohopper Charts',
  'coin.description': 'Free live {name} chart with real-time {base}/USDT candles from Binance, 38 indicators, drawing tools and price alerts. No account needed; the AI chart analyst is free with a Cryptohopper account.',
  'coin.heading': '{name} ({base}/USDT) chart',
  'coin.faqTitle': 'About the {name} chart',
  'coin.q.source': 'Where does the {name} price on this chart come from?',
  'coin.a.source': 'From Binance\'s public {base}/USDT market, streamed straight into your browser. The symbol search opens {base} against other quote currencies, or on Coinbase, Kraken, Bybit, OKX or Bitvavo where it is listed.',
  'coin.q.tools': 'Which tools can I use on the {name} chart?',
  'coin.a.tools': '38 indicators such as moving averages, RSI, MACD and Bollinger Bands, drawing tools from trend lines to Fibonacci, intervals from 1 minute to 1 month, up to 8 synced charts, price alerts and the Backtest Lab. No account needed.',
  'coin.q.signal': 'Is {name} a buy or a sell right now?',
  'coin.a.signal': 'The chart does not say, but two tools help you judge: the Signals page rates the 50 most-traded coins from 26 indicators, and the AI analyst can mark {name}\'s support, resistance and trend lines on this chart. Both are analysis, not financial advice.',
  'coin.q.alert': 'Can I get an alert when {name} reaches a price?',
  'coin.a.alert': 'Yes. Set an alert for {base} crossing, rising above or falling below a price; you get a browser notification while a Cryptohopper Charts tab is open.',
  'seo.popularCharts': 'Popular charts',

  // Backtest Lab (src/features/backtest)
  'bt.rail': 'Backtest',
  'bt.title': 'Backtest Lab',
  'bt.loading': 'Loading the Backtest Lab…',
  'bt.strategy': 'Strategy',
  'bt.custom': 'Custom strategy',
  'bt.template.ema-cross.name': 'EMA cross',
  'bt.template.ema-cross.description': 'Long when a fast EMA crosses above a slow one, flat when it crosses back. A classic trend follower.',
  'bt.template.ema-cross.input.fast': 'Fast EMA',
  'bt.template.ema-cross.input.slow': 'Slow EMA',
  'bt.template.ema-cross.input.entryPct': 'Entry size (% of balance)',
  'bt.template.rsi-dip.name': 'RSI dip',
  'bt.template.rsi-dip.description': 'Buys the bounce after RSI was oversold, sells on recovery or at a stop loss. RSI in its own pane.',
  'bt.template.rsi-dip.input.length': 'RSI length',
  'bt.template.rsi-dip.input.oversold': 'Oversold line',
  'bt.template.rsi-dip.input.exit': 'Exit line',
  'bt.template.rsi-dip.input.stopLossPct': 'Stop loss (%)',
  'bt.template.rsi-dip.input.entryPct': 'Entry size (% of balance)',
  'bt.template.bollinger-reversion.name': 'Bollinger reversion',
  'bt.template.bollinger-reversion.description': 'Buys a close below the lower Bollinger band and sells at the middle (or upper) band.',
  'bt.template.bollinger-reversion.input.length': 'Band length',
  'bt.template.bollinger-reversion.input.width': 'Width (standard deviations)',
  'bt.template.bollinger-reversion.input.target': 'Sell at',
  'bt.template.bollinger-reversion.input.entryPct': 'Entry size (% of balance)',
  'bt.template.macd-trend.name': 'MACD trend',
  'bt.template.macd-trend.description': 'Long when MACD crosses above its signal line with a positive histogram, flat on the opposite cross.',
  'bt.template.macd-trend.input.fastLength': 'Fast length',
  'bt.template.macd-trend.input.slowLength': 'Slow length',
  'bt.template.macd-trend.input.signalLength': 'Signal length',
  'bt.template.macd-trend.input.entryPct': 'Entry size (% of balance)',
  'bt.template.donchian-breakout.name': 'Donchian breakout',
  'bt.template.donchian-breakout.description': 'Turtle-style: buys a new N-bar high, sells a new M-bar low.',
  'bt.template.donchian-breakout.input.entryLength': 'Breakout length',
  'bt.template.donchian-breakout.input.exitLength': 'Exit length',
  'bt.template.donchian-breakout.input.entryPct': 'Entry size (% of balance)',
  'bt.template.supertrend.name': 'SuperTrend',
  'bt.template.supertrend.description': 'Follows the SuperTrend line: long when it flips bullish, flat when it flips bearish.',
  'bt.template.supertrend.input.atrLength': 'ATR length',
  'bt.template.supertrend.input.factor': 'ATR multiplier',
  'bt.template.supertrend.input.entryPct': 'Entry size (% of balance)',
  'bt.template.trend-filtered-dip.name': 'Trend-filtered dip',
  'bt.template.trend-filtered-dip.description': 'Buys a dip under a short EMA, but only while price is above a long SMA. Stop loss included.',
  'bt.template.trend-filtered-dip.input.trendLength': 'Trend SMA length',
  'bt.template.trend-filtered-dip.input.dipLength': 'Dip EMA length',
  'bt.template.trend-filtered-dip.input.dipPct': 'Dip below EMA (%)',
  'bt.template.trend-filtered-dip.input.stopLossPct': 'Stop loss (%)',
  'bt.template.trend-filtered-dip.input.entryPct': 'Entry size (% of balance)',
  'bt.customNote': 'Loaded from the AI analyst. Read-only: show the script',
  'bt.script': 'Strategy script, read-only',
  'bt.suggested': 'Tuned for {timeframe}.',
  'bt.idleTitle': 'Test a strategy on this chart',
  'bt.idleBody': 'Pick a strategy and press Run. You see every trade it would have made on the candles you are looking at.',
  'bt.readyHint': 'Press Run to test this strategy. Changing an input afterwards re-runs it automatically.',
  'bt.inputs': 'Inputs',
  'bt.inputsReset': 'Reset to defaults',
  'bt.inputsLoading': 'Reading the script…',
  'bt.noInputs': 'This strategy has no inputs.',
  'bt.between': '{min} to {max}',
  'bt.err.notNumber': 'Enter a number',
  'bt.err.notInteger': 'Whole numbers only',
  'bt.err.belowMin': 'At least {min}',
  'bt.err.aboveMax': 'At most {max}',
  'bt.err.offStep': 'Use steps of {step}',
  'bt.settingsSummary': '{bars} bars · {fee} bps fee',
  'bt.settings': 'Settings',
  'bt.bars': 'Bars to test',
  'bt.fee': 'Fee (basis points)',
  'bt.slippage': 'Slippage (basis points)',
  'bt.oos': 'Out-of-sample share (%)',
  'bt.runsOn': 'Runs on the active chart',
  'bt.run': 'Run backtest',
  'bt.rerun': 'Run again',
  'bt.cancel': 'Cancel',
  'bt.clear': 'Clear from chart',
  'bt.loadingCandles': 'Loading candles from the exchange…',
  'bt.running': 'Running the strategy…',
  'bt.results': 'Backtest results',
  'bt.kpi.return': 'Return',
  'bt.kpi.vsHold': 'Buy & hold {value}',
  'bt.beatsHold': 'Beats holding by {delta}',
  'bt.trailsHold': 'Trails holding by {delta}',
  'bt.levelHold': 'Same as holding',
  'bt.kpi.maxDrawdown': 'Max drawdown',
  'bt.kpi.winRate': 'Win rate',
  'bt.kpi.trades': 'Closed trades',
  'bt.kpi.profitFactor': 'Profit factor',
  'bt.kpi.sharpe': 'Sharpe ratio',
  'bt.kpi.exposure': 'Time in market',
  'bt.kpi.fees': 'Fees paid',
  'bt.moreStats': 'More stats',
  'bt.lessStats': 'Fewer stats',
  'bt.segments': 'In-sample and out-of-sample results',
  'bt.inSample': 'In-sample',
  'bt.outOfSample': 'Out-of-sample',
  'bt.bars.count': '{count} bars',
  'bt.tradesTitle': 'Trades',
  'bt.tradesTitleCount': 'Trades ({count})',
  'bt.tradesTitleOpen': 'Trades ({count} · {open} open)',
  'bt.tradesList': 'Trades. Use the arrow keys to move and Enter to show one on the chart.',
  'bt.long': 'Long',
  'bt.short': 'Short',
  'bt.open': 'open',
  'bt.emptyTitle': 'No trades',
  'bt.emptyBody': 'This strategy never traded on these {count} bars. Loosen its inputs or test more bars.',
  'bt.stale': 'This result is for {market}. The chart now shows something else, so the trades are off the chart. Run again to test the new market.',
  'bt.truncated': 'The exchange only has {count} bars of history for this market.',
  'bt.testedOn': '{count} bars of {market}',
  'bt.disclaimer': 'Simulation on historical data. Not financial advice.',
  'bt.card.title': 'Backtest result',
  'bt.card.market': '{market} · {timeframe} · {count} bars · {from} – {to}',
  'bt.card.oos': 'Out-of-sample ({count} bars): {value} against buy & hold {hold}, {trades} trades',
  'bt.card.openLab': 'Open in Lab',
  'bt.card.rerunCurrentTemplate': 'Re-run current template',
  'bt.card.templateChanged': 'This template changed since this result; the Lab will run the current version.',
  'bt.card.sourceUnavailable': 'Script unavailable after reload',
  'bt.error.unsupportedTimeframe': 'Backtests do not support the 1M timeframe. Switch the chart to 1W or shorter.',
  'bt.error.network': 'Could not load candles from the exchange. Check your connection and run again.',
  'bt.error.noData': 'The exchange has no closed candles for this market.',
  'bt.error.syntax': 'The script has a syntax error',
  'bt.error.script': 'The script failed while running',
  'bt.error.refused': 'The backtest was refused',
  'bt.error.timeout': 'The backtest took too long and was stopped',
  'bt.error.runtime': 'The backtest could not run',
  'bt.error.atLine': 'Line {line}, column {column}',
  'bt.error.atBar': 'In {handler} at bar {tick}',
  'term.changeSymbol': 'Change symbol',
  'term.changeSymbolHint': 'Change symbol (or just start typing)',
  'term.compare': 'Compare',
  'term.compareHint': 'Compare with another symbol',
  'term.compareTitle': 'Compare symbol',
  'term.alert': 'Alert',
  'term.createAlert': 'Create alert',
  'term.replay': 'Replay',
  'term.replayStart': 'Bar replay: pick a past bar and replay the market from there',
  'term.replayStop': 'Leave bar replay',
  'term.settings': 'Chart settings',
  'term.fullscreen': 'Full screen',
  'term.exitFullscreen': 'Exit full screen',
  'term.noFullscreen': 'Full screen is not available in this browser',
  'term.minutes': 'Minutes',
  'term.hours': 'Hours',
  'term.daysUp': 'Days and up',
  'term.allIntervals': 'All intervals',
  'term.crosshair': 'Crosshair',
  'term.timeRange': 'Time range',
  'term.layoutMenu': 'Chart layout',
  'term.layoutHint': 'Chart layout and sync',
  'term.chartsOnScreen': 'Charts on screen',
  'term.syncAcross': 'Sync across charts',
  'term.grid.1': 'One chart',
  'term.grid.2v': 'Two, side by side',
  'term.grid.2h': 'Two, stacked',
  'term.grid.3l': 'Three, one large',
  'term.grid.3c': 'Three columns',
  'term.grid.4': 'Four',
  'term.grid.6': 'Six',
  'term.grid.8': 'Eight',
  'term.saveLayoutHint': 'Save layout (Ctrl+S)',
  'term.layouts': 'Layouts',
  'term.saveLayout': 'Save layout',
  'term.saveAsNew': 'Save as new layout…',
  'term.savedLayouts': 'Saved layouts',
  'term.noLayouts': 'Nothing saved yet. Layouts are stored in this browser.',
  'term.layoutSaved': 'Layout “{name}” saved',
  'term.namePrompt': 'Name this layout',
  'term.nameCopy': '{name} copy',
  'term.loaded': 'Loaded “{name}”',
  'term.charts.one': '{count} chart',
  'term.charts.other': '{count} charts',
  'term.deleteName': 'Delete {name}',
  'term.share': 'Copy share link',
  'term.shareCopied': 'Link to this layout copied',
  'term.shareCopiedBody': 'Anyone with the link sees your charts, indicators and drawings.',
  'term.shareFailed': 'Could not copy the link',
  'term.shareFailedBody': 'Your browser blocked clipboard access.',
  'term.snapshot': 'Snapshot',
  'term.downloadImage': 'Download image',
  'term.copyImage': 'Copy image',
  'term.stillLoading': 'The chart is still loading',
  'term.imageCopied': 'Chart image copied',
  'term.copyUnsupported': 'Copying images is not supported here',
  'term.copyUnsupportedBody': 'Use “Download image” instead.',
  'term.watchlist': 'Watchlist',
  'term.alerts': 'Alerts',
  'term.objectTree': 'Object tree',
  'term.resizePanel': 'Resize panel',
  'term.loadingAnalyst': 'Loading the analyst…',
  'term.close': 'Close',
  'term.sidePanel': 'Side panel',
  'term.search.title': 'Symbol search',
  'term.search.placeholder': 'Search a coin or pair, e.g. BTC, ETHUSDT, SOL/EUR',
  'term.search.label': 'Search symbols',
  'term.search.allExchanges': 'All exchanges',
  'term.search.results': 'Results',
  'term.search.recent': 'Recent and popular',
  'term.search.loading': 'Loading markets…',
  'term.search.none': 'No market matches “{query}”. Try the coin ticker, like BTC or ETH.',
  'term.search.unreachable': 'Not reachable from your network: {list}.',
  'term.dateRange': 'Date range',
  'term.range.1d': '1 day, 5-minute bars',
  'term.range.5d': '5 days, 15-minute bars',
  'term.range.1m': '1 month, 1-hour bars',
  'term.range.3m': '3 months, 4-hour bars',
  'term.range.6m': '6 months, 12-hour bars',
  'term.range.ytd': 'Year to date, daily bars',
  'term.range.1y': '1 year, daily bars',
  'term.range.5y': '5 years, weekly bars',
  'term.showVolume': 'Show volume',
  'term.invertScale': 'Invert price scale',
  'term.percentScale': 'Percent scale',
  'term.logScale': 'Logarithmic scale',
  'term.regularScale': 'Regular price scale',
  'term.watch.add': 'Add',
  'term.watch.addHint': 'Add symbol to watchlist',
  'term.watch.addTitle': 'Add to watchlist',
  'term.watch.newList': 'New list…',
  'term.watch.newListPrompt': 'Name the new list',
  'term.watch.defaultName': 'My list',
  'term.watch.deleteConfirm': 'Delete “{name}”?',
  'term.watch.last': 'Last',
  'term.watch.empty': 'Add symbols to follow their prices here.',
  'term.watch.remove': 'Remove {base}',
  'term.details.label': 'Symbol details',
  'term.details.range': '24h range',

  // Backtest Lab rules: the sentence describing a rule-built strategy (features/backtest/rules/sentence.ts).
  'bt.rules.buyWhen': 'Buy when {conditions}.',
  'bt.rules.sellWhen': 'Sell when {conditions}.',
  'bt.rules.and': 'and',
  'bt.rules.or': 'or',
  'bt.rules.op.crossesAbove': '{left} crosses above {right}',
  'bt.rules.op.crossesBelow': '{left} crosses below {right}',
  'bt.rules.op.above': '{left} is above {right}',
  'bt.rules.op.below': '{left} is below {right}',
  'bt.rules.price': 'close',
  'bt.rules.level': 'the line at {price}',
  'bt.rules.stopLoss': 'the loss reaches {pct}%',
  'bt.rules.takeProfit': 'the profit reaches {pct}%',
  'bt.rules.empty': 'No rules yet.',
  ...ruleEnglishFallbacks,
  'draw.lines': 'Lines',
  'draw.fib': 'Fibonacci',
  'draw.shapes': 'Shapes',
  'draw.text': 'Text',
  'draw.trading': 'Trading',
  'draw.trendline': 'Trend line',
  'draw.ray': 'Ray',
  'draw.extendedLine': 'Extended line',
  'draw.horizontalLine': 'Horizontal line',
  'draw.horizontalRay': 'Horizontal ray',
  'draw.verticalLine': 'Vertical line',
  'draw.parallelChannel': 'Parallel channel',
  'draw.fibRetracement': 'Fib retracement',
  'draw.rectangle': 'Rectangle',
  'draw.arrow': 'Arrow',
  'draw.longPosition': 'Long position',
  'draw.shortPosition': 'Short position',
  'draw.measure': 'Measure',
  'draw.more': 'More tools: {group}',
  'draw.cursor': 'Cursor (Esc)',
  'draw.magnetOn': 'Magnet on: snaps to open/high/low/close',
  'draw.magnetOff': 'Magnet off',
  'draw.keepOn': 'Stay in drawing mode: on',
  'draw.keepOff': 'Stay in drawing mode: off',
  'draw.lockAll': 'Lock all drawings',
  'draw.unlockAll': 'Unlock all drawings',
  'draw.show': 'Show drawings',
  'draw.hide': 'Hide drawings',
  'draw.removeAll': 'Remove all drawings',
  'draw.removeConfirm.one': 'Remove {count} drawing from this chart?',
  'draw.removeConfirm.other': 'Remove all {count} drawings from this chart?',
  'settings.done': 'Done',
  'settings.localTime': 'Local time',
  'tz.london': 'London',
  'tz.amsterdam': 'Amsterdam',
  'tz.istanbul': 'Istanbul',
  'tz.dubai': 'Dubai',
  'tz.mumbai': 'Mumbai',
  'tz.singapore': 'Singapore',
  'tz.hongKong': 'Hong Kong',
  'tz.tokyo': 'Tokyo',
  'tz.sydney': 'Sydney',
  'tz.newYork': 'New York',
  'tz.chicago': 'Chicago',
  'tz.losAngeles': 'Los Angeles',
  'tz.saoPaulo': 'São Paulo',
  'settings.watermark': 'Symbol watermark',
  'settings.activeChart': 'Active chart',
  'settings.priceScale': 'Price scale',
  'settings.regular': 'Regular',
  'settings.log': 'Logarithmic',
  'settings.percent': 'Percent',
  'settings.indexed': 'Indexed to 100',
  'settings.invert': 'Invert scale',
  'term.toast.sharedLoaded': 'Shared layout loaded',
  'term.toast.sharedSaved': 'Your previous charts are saved as “{name}” in Layouts.',
  'term.toast.sharedNotSaved': 'Your previous charts could not be saved in this browser. Restore them now if you want to keep them.',
  'term.toast.restore': 'Restore my layout',
  'term.toast.damaged': 'This share link is damaged',
  'term.toast.symbolNotFound': 'Symbol “{symbol}” was not found',
  'term.toast.unreachable': 'Exchange not reachable. Check your connection and reload.',
  'term.interval.title': 'Change interval',
  'term.interval.enter': '{interval}: press Enter',
  'term.interval.hint': 'Try 1, 15, 60, 4h, D, W',
  'alerts.tab': 'Alerts ({count})',
  'alerts.log': 'Log',
  'alerts.new': 'New',
  'alerts.clear': 'Clear',
  'alerts.empty': 'No alerts yet',
  'alerts.emptyText': 'Get notified when a price crosses a level. Alerts run while this site is open in a tab.',
  'alerts.active': 'Active',
  'alerts.triggered': 'Triggered {time}',
  'alerts.paused': 'Paused',
  'alerts.rearm': 'Re-arm',
  'alerts.rearmLabel': 'Re-arm alert',
  'alerts.delete': 'Delete',
  'alerts.deleteLabel': 'Delete alert',
  'alerts.logEmpty': 'Triggered alerts appear here.',
  'alerts.dialogTitle': 'Create alert on {ticker}',
  'alerts.cancel': 'Cancel',
  'alerts.lastPrice': '{exchange} · last price {price}',
  'alerts.condition': 'Condition',
  'alerts.crosses': 'Price crosses',
  'alerts.risesAbove': 'Price rises above',
  'alerts.fallsBelow': 'Price falls below',
  'alerts.note': 'Note (optional)',
  'alerts.notePlaceholder': 'e.g. Breakout above the range',
  'alerts.dialogHint': 'Alerts run in your browser while Cryptohopper Charts is open in a tab. You get a notification and a sound when one triggers.',
  'alerts.created': 'Alert created',
  'alerts.describe.crossing': '{ticker} crosses {price}',
  'alerts.describe.above': '{ticker} rises above {price}',
  'alerts.describe.below': '{ticker} falls below {price}',
  'alerts.fired': '{alert}, now {price}',
  'alerts.firedToast': 'Alert triggered',
  'alerts.notificationTitle': 'Cryptohopper Charts alert',
  'tree.indicators': 'Indicators ({count})',
  'tree.noIndicators': 'None on this chart.',
  'tree.drawings': 'Drawings ({count})',
  'tree.noDrawings': 'Use the tools on the left to draw on the chart.',
  'tree.settings': 'Settings',
  'tree.hide': 'Hide',
  'tree.show': 'Show',
  'tree.remove': 'Remove',
  'tree.lock': 'Lock',
  'tree.unlock': 'Unlock',
  'ind.favorites': 'Favorites',
  'ind.all': 'All indicators',
  'ind.trend': 'Trend',
  'ind.search': 'Search indicators',
  'ind.categories': 'Indicator categories',
  'ind.favEmpty': 'Star an indicator to keep it here.',
  'ind.none': 'No indicator matches “{query}”.',
  'ind.favAdd': 'Add {name} to favorites',
  'ind.favRemove': 'Remove {name} from favorites',
  'ind.added': '{name} added',
  'ind.overlay': 'On price',
  'ind.pane': 'Own pane',
  'ind.desc.sma': 'Average price over a set number of periods',
  'ind.desc.ema': 'Moving average that weights recent prices more',
  'ind.desc.wma': 'Linearly increasing weights to more recent data',
  'ind.desc.dema': 'Reduces lag compared to a single EMA',
  'ind.desc.tema': 'Removes most of the lag of standard moving averages',
  'ind.desc.hma': 'Fast, smooth moving average with very little lag',
  'ind.desc.vwma': 'Moving average weighted by volume',
  'ind.desc.env': 'Bands a fixed percentage above and below a moving average',
  'ind.desc.adx': 'Strength of a trend regardless of direction, with +DI / −DI',
  'ind.desc.ichimoku': 'Support/resistance, momentum and trend direction in one view',
  'ind.desc.psar': 'Trailing stop that flips with the trend',
  'ind.desc.supertrend': 'ATR-based trend-following line',
  'ind.desc.aroon': 'How recently the highest high and lowest low occurred',
  'ind.desc.rsi': 'Speed and magnitude of recent price changes',
  'ind.desc.macd': 'Relationship between two exponential moving averages',
  'ind.desc.stoch': 'Close relative to the high-low range of a period',
  'ind.desc.stochrsi': 'Stochastic applied to RSI — a faster, more sensitive RSI',
  'ind.desc.cci': 'Price relative to its statistical mean',
  'ind.desc.willr': 'Close relative to the period high, 0 to −100',
  'ind.desc.roc': 'Percent change versus N bars ago',
  'ind.desc.mom': 'Price difference versus N bars ago',
  'ind.desc.ao': 'Difference of 5- and 34-period averages of the bar midpoint',
  'ind.desc.trix': 'Rate of change of a triple-smoothed EMA',
  'ind.desc.uo': 'Buying pressure averaged over three windows',
  'ind.desc.cmo': 'Net up minus down momentum, −100 to 100',
  'ind.desc.bb': 'Bands at standard deviations around a moving average',
  'ind.desc.bbp': 'Where the close sits within the Bollinger Bands',
  'ind.desc.bbw': 'Width of the Bollinger Bands relative to the basis',
  'ind.desc.atr': 'Average size of the bar range including gaps',
  'ind.desc.kc': 'ATR bands around an EMA',
  'ind.desc.dc': 'Highest high and lowest low of a period',
  'ind.desc.stdev': 'Dispersion of the close around its mean',
  'ind.desc.vwap': 'Volume-weighted average price, resetting daily (UTC)',
  'ind.desc.obv': 'Cumulative volume flow by close direction',
  'ind.desc.mfi': 'Volume-weighted RSI',
  'ind.desc.cmf': 'Accumulation versus distribution over a period',
  'ind.desc.vpvr': 'Volume traded at each price in view, with point of control and value area',
  'ind.desc.volma': 'Moving average of volume, drawn over the volume bars',
  'replay.stopped': 'Replay stopped',
  'replay.stoppedBody': 'This interval has no data that far back.',
  'replay.end': 'Replay reached the latest bar',
  'replay.endBody': 'Exit the replay to go back to the live chart.',
  'replay.pick': 'Click a bar to start the replay there',
  'replay.esc': '(Esc to cancel)',
  'replay.toolbar': 'Bar replay',
  'replay.repick': 'Pick another start bar',
  'replay.back': 'Back one bar (Shift+←)',
  'replay.play': 'Play',
  'replay.pause': 'Pause',
  'replay.forward': 'Forward one bar (Shift+→)',
  'replay.speed': 'Replay speed',
  'replay.speedHint': 'Bars per second',
  'replay.exit': 'Exit replay',
  'ctx.alertAt': 'Add alert at {price}',
  'ctx.lineAt': 'Draw horizontal line at {price}',
  'ctx.reset': 'Reset chart view',
  'watch.majors': 'Crypto majors',
  'layout.untitled': 'Untitled layout',
  'layout.shared': 'Shared layout',
  'layout.backup': 'Before shared layout',
  // Trading calculators (features/calculators/).
  'nav.calculators': 'Calculators',
  'page.calculators.title': 'Crypto trading calculators: position size, profit/loss, DCA and pivot points · Cryptohopper Charts',
  'page.calculators.description': 'Free crypto trading calculators: size a position from your balance, risk and stop-loss, work out profit or loss after exchange fees, and see what a DCA plan in Bitcoin or another top coin would be worth today. Works in your browser, no account needed.',
  'page.calculators.heading': 'Crypto trading calculators',
  'calc.lead': 'Size a trade from the risk you are willing to take, see what a trade nets after fees, and work out what buying a coin on a schedule (DCA) would be worth today. Amounts are in your quote currency, such as USDT, USD or EUR.',
  'calc.note': 'Everything is worked out in your browser. Fees, spreads and slippage differ per exchange and order type. These are calculations, not financial advice.',
  'calc.position.title': 'Position size',
  'calc.position.text': 'How much to buy or sell short so that hitting your stop-loss costs exactly the share of your balance you chose.',
  'calc.balance': 'Account balance',
  'calc.riskPct': 'Risk per trade',
  'calc.entry': 'Entry price',
  'calc.stop': 'Stop-loss price',
  'calc.target': 'Take-profit price',
  'calc.optional': 'optional',
  'calc.positionSize': 'Position size',
  'calc.positionValue': 'Position value',
  'calc.riskAmount': 'Amount at risk',
  'calc.rewardRisk': 'Reward to risk',
  'calc.long': 'long',
  'calc.short': 'short',
  'calc.positionInvalid': 'Enter a balance, a risk between 0 and 100% and an entry and stop-loss price that differ.',
  'calc.pnl.title': 'Profit and loss',
  'calc.pnl.text': 'What a trade nets after the exchange fee on the buy and on the sell.',
  'calc.invested': 'Amount to invest',
  'calc.feePct': 'Fee per trade',
  'calc.buy': 'Buy price',
  'calc.sell': 'Sell price',
  'calc.netPnl': 'Net profit or loss',
  'calc.returnPct': 'Return',
  'calc.sellValue': 'Sell value',
  'calc.fees': 'Fees paid',
  'calc.pnlInvalid': 'Enter an amount, a buy and sell price above zero and a fee below 100%.',
  'calc.avg.title': 'Average price calculator',
  'calc.avg.text': 'Your average cost per coin after several buys at different prices, and the price at which selling everything breaks even after fees.',
  'calc.avg.amount': 'Amount spent',
  'calc.avg.add': 'Add a buy',
  'calc.avg.remove': 'Remove buy {n}',
  'calc.avg.breakEven': 'Break-even price',
  'calc.avg.invalid': 'Enter an amount and a price above zero for every buy, and a fee below 100%.',
  'calc.dca.title': 'DCA calculator',
  'calc.dca.text': 'What buying a fixed amount of a coin every day, week or month would be worth today, worked out from Binance’s daily closing prices.',
  'calc.dca.amount': 'Amount per buy',
  'calc.dca.every': 'Buy every',
  'calc.dca.day': 'Day',
  'calc.dca.week': 'Week',
  'calc.dca.month': 'Month',
  'calc.dca.period': 'Over the last',
  'calc.dca.6m': '6 months',
  'calc.dca.1y': '1 year',
  'calc.dca.2y': '2 years',
  'calc.dca.3y': '3 years',
  'calc.dca.5y': '5 years',
  'calc.dca.invested': 'Total invested',
  'calc.dca.value': 'Value now',
  'calc.dca.coins': 'Coins bought',
  'calc.dca.average': 'Average buy price',
  'calc.dca.lumpSum': 'All on day one',
  'calc.dca.span': '{buys} buys from {from} to {to}, at Binance’s daily close against USDT.',
  'calc.dca.loading': 'Loading daily prices from Binance…',
  'calc.dca.error': 'Daily prices could not be loaded. Binance blocks some countries and networks; try again later.',
  'calc.dca.invalid': 'Enter an amount above zero and a fee below 100%.',
  'calc.pivot.title': 'Pivot points',
  'calc.pivot.text': 'Support and resistance levels for the current day, week or month, worked out from the previous one’s high, low and close with the classic, Fibonacci, Woodie and Camarilla formulas. The prices fill in from Binance; type your own to use them instead.',
  'calc.pivot.period': 'Pivots for',
  'calc.pivot.day': 'Today',
  'calc.pivot.week': 'This week',
  'calc.pivot.month': 'This month',
  'calc.pivot.high': 'Previous high',
  'calc.pivot.low': 'Previous low',
  'calc.pivot.close': 'Previous close',
  'calc.pivot.level': 'Level',
  'calc.pivot.classic': 'Classic',
  'calc.pivot.woodie': 'Woodie',
  'calc.pivot.camarilla': 'Camarilla',
  'calc.pivot.source': 'Filled in from the {base}/USDT candle that opened {date} (UTC) on Binance.',
  'calc.pivot.loading': 'Loading prices from Binance…',
  'calc.pivot.error': 'The prices could not be loaded from Binance, which blocks some countries and networks. Type in a high, low and close to work out the levels.',
  'calc.pivot.invalid': 'Enter a high, low and close above zero, with the high at or above the low.',
  'calc.fib.title': 'Fibonacci retracement',
  'calc.fib.text': 'Retracement and extension levels of a price swing. After a rise the retracements count down from the high and the extensions reach above it; after a fall they count up from the low and reach below it. The swing fills in from Binance; type your own high and low to use them instead.',
  'calc.fib.range': 'Swing over',
  'calc.fib.days30': 'Last 30 days',
  'calc.fib.days90': 'Last 90 days',
  'calc.fib.days365': 'Last year',
  'calc.fib.high': 'Swing high',
  'calc.fib.low': 'Swing low',
  'calc.fib.trend': 'Move',
  'calc.fib.up': 'Rise (low, then high)',
  'calc.fib.down': 'Fall (high, then low)',
  'calc.fib.retracements': 'Retracements',
  'calc.fib.extensions': 'Extensions',
  'calc.fib.source': 'Filled in from the highest high and lowest low of {base}/USDT on Binance in the last {days} days.',
  'calc.fib.error': 'The prices could not be loaded from Binance, which blocks some countries and networks. Type in a swing high and low to work out the levels.',
  'calc.fib.invalid': 'Enter a swing high and low above zero, with the high above the low.',
  'calc.faqTitle': 'Questions about the calculators',
  'calc.faq.position.q': 'How do I work out my position size?',
  'calc.faq.position.a': 'Decide how much of your balance you are willing to lose on the trade, for example 1%, and where your stop-loss goes. The position size is that amount divided by the distance between entry and stop: with a balance of 10,000, 1% risk, an entry at 100 and a stop at 95, you buy 20 coins, a position worth 2,000.',
  'calc.faq.pivots.q': 'What are pivot points and how are they used?',
  'calc.faq.pivots.a': 'Pivot points are support and resistance levels worked out from the previous day’s, week’s or month’s high, low and close. P is the central level, with R1 to R3 above it and S1 to S3 below. Traders watch them as areas where the price may stall or turn, and use them for targets and stops. The methods differ in their formulas: Fibonacci levels use 38.2%, 61.8% and 100% of the range, and Camarilla levels sit close to the previous close.',
  'calc.faq.fibonacci.q': 'How do I use Fibonacci retracement levels?',
  'calc.faq.fibonacci.a': 'Pick a coin and a period to fill in its swing high and low, or type your own. After a rise, the retracements show how far a pullback may go before the uptrend resumes; 38.2%, 50% and 61.8% are watched most. The extensions, such as 161.8%, are common targets past the high. After a fall it works the other way round: the retracements are levels a bounce may reach, and the extensions sit below the low.',
  'calc.faq.dca.q': 'What is dollar-cost averaging (DCA)?',
  'calc.faq.dca.a': 'Buying a fixed amount at regular intervals, whatever the price, instead of investing everything at once. You buy more coins when the price is low and fewer when it is high. The DCA calculator shows what such a plan in Bitcoin or another major coin would be worth today, next to putting the whole amount in on the first day.',
  'calc.faq.average.q': 'How is the average buy price worked out?',
  'calc.faq.average.a': 'Add up everything you spent, fees included, and divide it by the number of coins you received. A buy at a lower price brings more coins, so it pulls the average down more than the same amount spent at a higher price. To break even you need a bit more than the average, because selling costs a fee too.',
  'calc.faq.fees.q': 'Are exchange fees included?',
  'calc.faq.fees.a': 'The profit and loss calculator charges the fee you enter on both the buy and the sell, and the DCA calculator on every buy. Spreads, slippage and funding costs are not included; they differ per exchange and order type.',

  // Crypto converter page (features/converter/).
  'nav.converter': 'Converter',
  'page.converter.title': 'Crypto converter: Bitcoin, Ethereum and the top 100 coins to US dollars · Cryptohopper Charts',
  'page.converter.description': 'Free crypto to USD converter for the top 100 coins at the current market price. Type an amount of a coin or of dollars and see the other, with quick tables for common amounts.',
  'page.converter.heading': 'Crypto converter',
  'conv.lead': 'Convert between a coin and US dollars at the current price, for the top 100 coins by market cap. Prices come from CoinGecko and refresh every few minutes.',
  'conv.coin': 'Coin',
  'conv.amountIn': 'Amount in {unit}',
  'conv.rate': '1 {base} = {price}',
  'conv.updated': 'CoinGecko price, updated {time}',
  'conv.toUsd': '{base} to US dollar',
  'conv.fromUsd': 'US dollar to {base}',
  'conv.loading': 'Loading prices',
  'conv.note': 'An indication of the market price across exchanges, not a quote: the price you get on an exchange depends on its order book and fees.',
  'conv.faqTitle': 'Questions about the converter',
  'conv.faq.prices.q': 'Where does the converter get its prices?',
  'conv.faq.prices.a': 'From CoinGecko’s market data: one price per coin, drawn from many exchanges rather than from a single one. The converter fetches new prices every five minutes and shows when it last did.',
  'conv.faq.exchange.q': 'Is this the price I get on an exchange?',
  'conv.faq.exchange.a': 'Not exactly. Every exchange has its own order book, so its price can be a little higher or lower, and it charges a trading fee on top. The Compare tab on the Markets page shows the price of the largest coins on six exchanges side by side.',
  'conv.faq.coins.q': 'Which coins can I convert?',
  'conv.faq.coins.a': 'The 100 largest coins by market cap, to and from US dollars. Bitcoin, Ethereum, Solana, XRP, BNB, Dogecoin and Cardano are one click away; pick any other coin from the list.',
  'conv.faq.share.q': 'Can I share a conversion?',
  'conv.faq.share.a': 'Yes. The page address keeps the coin, for example /converter?coin=eth for Ethereum, so a link opens the converter on the same coin.',
  'nav.glossary': 'Glossary',
  'page.glossary.title': 'Crypto trading glossary: RSI, MACD, candlesticks and more · Cryptohopper Charts',
  'page.glossary.description': 'Plain definitions of 20 crypto trading terms, from candlesticks, support and resistance to RSI, MACD, volatility, correlation, DCA and altcoin season, each linked to the free tool that uses it.',
  'page.glossary.heading': 'Crypto trading glossary',
  'glossary.lead': 'The terms behind the charts, signals and calculators on this site, each explained in a sentence or two, with a link to the tool where you can see it at work.',
  'glossary.index': 'All terms',
  'glossary.candlestick': 'Candlestick',
  'glossary.candlestick.def': 'A bar that shows one period’s open, high, low and close. The body runs from the open to the close, the wicks reach the high and the low, and its colour shows whether the price rose or fell.',
  'glossary.supportResistance': 'Support and resistance',
  'glossary.supportResistance.def': 'Price levels where buying (support) or selling (resistance) has tended to stop a move. Traders draw them from earlier highs and lows or work them out as pivot points.',
  'glossary.trendLine': 'Trend line',
  'glossary.trendLine.def': 'A line through two or more highs or lows that shows the direction of a trend. A clear break through it can be a sign that the trend is changing.',
  'glossary.movingAverage': 'Moving average (SMA, EMA)',
  'glossary.movingAverage.def': 'The average closing price of the last N candles, recalculated every candle. The simple average (SMA) weighs every candle the same; the exponential one (EMA) weighs recent candles more, so it turns sooner.',
  'glossary.rsi': 'RSI (Relative Strength Index)',
  'glossary.rsi.def': 'A momentum oscillator from 0 to 100 that compares recent gains with recent losses, usually over 14 candles. 70 or above is called overbought, 30 or below oversold.',
  'glossary.macd': 'MACD',
  'glossary.macd.def': 'The difference between a 12- and a 26-period EMA, drawn with a 9-period EMA of itself as the signal line. The MACD crossing its signal line is read as a change in momentum.',
  'glossary.bollinger': 'Bollinger Bands',
  'glossary.bollinger.def': 'A 20-period moving average with a band two standard deviations above and below it. The bands widen when the price swings more and narrow when it calms down.',
  'glossary.pattern': 'Candlestick pattern',
  'glossary.pattern.def': 'A shape of one to three candles, such as a hammer, a doji or an engulfing candle, that traders read as a hint of a reversal or a continuation. A hint, not a forecast.',
  'glossary.volatility': 'Volatility',
  'glossary.volatility.def': 'How much a price swings. Realized volatility is the standard deviation of daily returns, scaled to a year; higher means bigger moves in both directions.',
  'glossary.correlation': 'Correlation',
  'glossary.correlation.def': 'How closely two prices move together, from −1 (opposite moves) through 0 (no relation) to 1 (in step), measured on their daily returns.',
  'glossary.marketCap': 'Market cap',
  'glossary.marketCap.def': 'A coin’s price times its circulating supply: what all coins in circulation are worth at today’s price. Coins are usually ranked by it.',
  'glossary.volume': 'Trading volume',
  'glossary.volume.def': 'The value traded over a period, usually the last 24 hours. More volume means more trades and usually a more reliable price.',
  'glossary.orderBook': 'Order book',
  'glossary.orderBook.def': 'The list of open buy and sell orders on an exchange at each price. It decides the price you actually get when you buy or sell.',
  'glossary.spread': 'Spread',
  'glossary.spread.def': 'The gap between the highest buy order and the lowest sell order, or between a coin’s price on two exchanges. A smaller spread means cheaper trading.',
  'glossary.stopLoss': 'Stop-loss',
  'glossary.stopLoss.def': 'An order that closes a trade when the price reaches a level you set, to limit the loss. Position sizing starts from the distance between entry and stop-loss.',
  'glossary.takeProfit': 'Take-profit',
  'glossary.takeProfit.def': 'An order that closes a trade at a profit when the price reaches a target you set.',
  'glossary.dca': 'DCA (dollar-cost averaging)',
  'glossary.dca.def': 'Buying a fixed amount at regular intervals, whatever the price, so you buy more when the price is low and less when it is high.',
  'glossary.altseason': 'Altcoin season',
  'glossary.altseason.def': 'A period in which most large altcoins beat Bitcoin. The altcoin season index counts how many of the 50 largest coins rose more than Bitcoin over the last 90 days.',
  'glossary.dominance': 'Bitcoin dominance',
  'glossary.dominance.def': 'Bitcoin’s share of the total crypto market cap. A rising share means money is moving into Bitcoin, a falling one into altcoins.',
  'glossary.pivots': 'Pivot points',
  'glossary.pivots.def': 'Support and resistance levels worked out from the previous day’s, week’s or month’s high, low and close, with formulas such as classic, Fibonacci, Woodie and Camarilla.',
} as const;

export type MessageKey = keyof typeof en;
type PluralBase = { [K in MessageKey]: K extends `${infer Base}.other` ? Base : never }[MessageKey];
/**
 * Every English key, plus the extra plural forms a language uses beyond one/other (Polish: few, many).
 * plural() in lib/i18n.ts picks the form Intl.PluralRules names and falls back to .other.
 */
export type Messages = Record<MessageKey, string> & Partial<Record<`${PluralBase}.${'zero' | 'two' | 'few' | 'many'}`, string>>;
